<template>
  <div>
        <v-layout v-if="$route.name === 'newlandingpage'" column 
            style="z-index:7;position: fixed;bottom: 130px;left: 50px;" >
            <v-btn icon x-large @click="Toolbar = !Toolbar"><v-icon  color="purple" x-large>mdi-tools</v-icon></v-btn>							
        </v-layout>
      <v-dialog v-model="NewWikiFieldDialog" width="400px">
           <v-card width="400px">									
            <v-card-title>									
                New Wiki Field									
                </v-card-title>	
                <v-card-text>                    								
                <v-text-field v-model="NewFieldName" label="Name"></v-text-field>  
                <v-text-field v-model="NewfieldType" readonly label="Type"></v-text-field>    
                </v-card-text>                                                   									
                <v-card-actions>
                    <v-btn @click="CancelAddNewWikiField()">Cancel</v-btn>
                    <v-spacer>
                    </v-spacer>									
                    <v-btn v-if="NewFieldName !== ''" @click="AddNewWikiField()">Save</v-btn>									
                </v-card-actions>									
            </v-card>
      </v-dialog>
       <v-dialog max-width="500" v-model="NewTableOptionDialog">        
        <v-card>
            <v-card-title class="overline">
                {{NewTableOption.OptionType}}
            </v-card-title>
            <v-card-text v-html="NewTableOption.Description">
            </v-card-text>
            <v-card-text>
                
                <v-list dense>
                    <v-list-item>
                        <v-text-field :filled="NewTableOption.id" :readonly="NewTableOption.id" v-model="NewTableOption.Name" label="Name" />
                    </v-list-item>
                    <v-list-item>
                        <v-text-field v-model="NewTableOption.DisplayName" label="DisplayName" />
                    </v-list-item>
                </v-list>
                <v-list dense v-if="NewTableOption.OptionType === 'Document Register' || NewTableOption.OptionType === 'Gallery'">
                    <v-list-item>
                    <v-select v-model="NewTableOption.CreatePermission" label="Create" :items="['Inherited','Custom Role','Admin']"/>
                    </v-list-item>
                    <v-list-item>
                    <v-select v-model="NewTableOption.GetPermission" label="Get (Open)" :items="['Inherited','Custom Role','Admin']"/>
                    </v-list-item>
                    <v-list-item>
                    <v-select v-model="NewTableOption.ListPermission" label="See the list" :items="['Inherited','Custom Role','Admin']"/>
                    </v-list-item>
                    <v-list-item>
                    <v-select v-model="NewTableOption.UpdatePermission" label="Update (e.g. change Class, or Table)" :items="['Inherited','Custom Role','Admin']"/>
                    </v-list-item>
                    <v-list-item>
                    <v-select v-model="NewTableOption.DeletePermission" label="Delete" :items="['Inherited','Custom Role','Admin']"/>
                    </v-list-item>
                    <v-list-item dense v-if="NewTableOption.OptionType === 'Document Register'">
                        <v-btn @click="Onepropemit('ActivateOptionSetDialog',NewTableOption)">Options</v-btn>
                    </v-list-item>
                </v-list>
                <v-list  v-if="NewTableOption.OptionType === 'SubCollection'">
                    <v-list-item>
                            <v-chip-group
                            active-class="primary--text"
                            column
                        >
                        <v-chip
                            @click="ActivateNewFieldDialog(field,true)"
                            small  v-for="field in FieldTypesSearched"
                            :key="field.itemObjKey"
                            >
                            {{field.Type}}
                            </v-chip>                           
                        </v-chip-group>
                    </v-list-item>
                    <v-list-item>
                                <v-dialog v-model="importdialog" max-width="500px">
                                    <template v-slot:activator="{ on }">
                                        <v-btn color="green" dark class="mb-2" v-on="on">Import</v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                        <span class="headline">Import Dialog</span>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row>
                                            <v-col cols="12" sm="12" md="12" lg="12">
                                                <v-text-field v-model="ImportFileSessionName" label="Name"></v-text-field>
                                                <input v-if="!ImportFile"
                                                        type="file"
                                                        @change="onImportfileSelected($event)"
                                                        ref="ImportFileinputter"
                                                        id="fileUpload"
                                                        >
                                                <v-btn @click="DownloadFieldsImportTemplate()">Download Template</v-btn>
                                            </v-col>
                                            </v-row>
                                        </v-card-text>
                                        <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="closeImport()">Cancel</v-btn>
                                        <v-btn color="blue darken-1" text @click="saveImport()">Save</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                    </v-dialog>
                            </v-list-item>
                        <v-list-item>
                            <!-- {{NewTableOption.Headers}} -->
                        <!-- <v-autocomplete return-object multiple chips v-model="NewTableOption.Headers" :items="NewTableOption.Headers" label="Headers" item-text="Name" readonly>
                            <template v-slot:selection="data">
                                 -->
                                  <v-chip-group
                            active-class="primary--text"
                            column
                        >
                                <v-chip
                                    @click="ActivateNewFieldDialog(field,true)"
                                    small  v-for="(field) in NewTableOption.Headers"
                                    :key="field.itemObjKey"
                                    >
                                    {{field.Name}}
                                    </v-chip>     
                                  </v-chip-group>                      
<!--                                 
                            </template>
                        </v-autocomplete> -->
                    </v-list-item>
                    <v-list-item>
                        <v-select @change="ResetTableOptionDialog()" v-model="NewTableOption.Type" label="Type" :items="['Lookup','Standard']"/>
                    </v-list-item>
                    <!-- NewTableOption.Type {{NewTableOption.Type}} -->
                    <v-list-item v-if="NewTableOption.Type === 'Lookup'">
                            <!-- @change="UpdateRelated(field,field.RelatedBuildID)" -->
                        <v-select                                                   
                            v-model="NewTableOption.LookupBuilds"
                            :items="LookupEntitiesSubCols"
                            class="mx-2"
                            item-text="id"
                            label="Lookup Builds"
                            multiple
                            return-object
                             @change="ResetTableOptionDialog()"
                            ></v-select>
                            
                    </v-list-item>
                    <v-list  v-if="NewTableOption.Type === 'Lookup'">
                        <v-list-item class="black">
                            <v-list-item-content class="white--text">
                                Related DataSet
                            </v-list-item-content>
                            <v-list-item-content class="white--text" v-for="header in NewTableOption.Headers" :key="header.itemObjKey">
                                {{header.Name}}
                            </v-list-item-content>
                            </v-list-item>
                        <v-list-item v-for="build in NewTableOption.LookupBuilds" :key="build.itemObjKey">
                            <v-list-item-content>
                                {{build.tempname}}
                            </v-list-item-content>                                                        
                            <v-list-item-content v-for="(header,headerindex) in NewTableOption.Headers" :key="header.itemObjKey">
                                    <v-autocomplete @change="CheckForPrimary(NewTableOption,build.LinkedFields[header.value],header,headerindex)" dense :label="header.text" v-model="build.LinkedFields[header.value]" :items="build.AllFields" item-text="DisplayName" return-object></v-autocomplete>
                            </v-list-item-content>
                        </v-list-item>                                                
                    </v-list>
                    
                    <v-list-item v-if="NewTableOption.Type === 'Lookup'">
                        <v-switch v-model="NewTableOption.Lookup_Once_Only" label="Records can link Once Only" />
                    </v-list-item>
                    <v-list-item>
                        <v-switch v-model="NewTableOption.ConfigValueasDocID" label="ConfigValueasDocID" />
                    </v-list-item>
                    <v-list-item v-if="NewTableOption.ConfigValueasDocID">
                        <v-select                                                   
                            v-model="NewTableOption.DocIDProp"
                            :items="NewTableOption.Headers"
                            class="mx-2"
                            item-text="Name"
                            label="DocIDProp"
                            
                            ></v-select>
                    </v-list-item>
                    
                </v-list>
            </v-card-text>
            <v-card-text>
                <!-- <v-btn @click="ResetTableOptionDialog()">Refresh</v-btn> -->
                <TableEmbedTab 	v-if="SampleTableOption.OptionType === 'SubCollection' && SampleTableOption.Entityid"	
                :PageHeadersFont="PageHeadersFont" :PageContentFont="PageContentFont"									
                :PageHeadersFontSize="PageHeadersFontSize" :i="index" :IsElement="true" :tabindex="''" :rowindex="rowindex"		
                :SystemEntities="SystemEntities" :RelatedObj="RelatedObj" :EntityCollectionRef="EntityCollectionRef" :EntityDataRef="EntityDataRef"					
                :tab="SampleTableOption" @OpenDialog="OpenDialog" :ParentTab="''" :DynamicWikiData="SampleRecord"									
                />
                <!-- <DataSingleDocumentRegister :EntityName="EntityName" :BaseStorageRef="BaseStorageRef"
                :Record="Record" 	v-if="SampleTableOption.OptionType === 'Document Register' && SampleTableOption.Entityid"	
                :SystemEntities="SystemEntities" :SingleFormEditing="SingleFormEditing" :EntityCollectionRef="EntityCollectionRef" :EntityDataRef="EntityDataRef"
                @OpenDialog="OpenDialog" :sectionindex="sectionindex" @ActivateUploadingSingleFileNotification="ActivateUploadingSingleFileNotification"
                :Business_Unit="Business_Unit" :PrimaryFieldName="PrimaryFieldName" :RelatedObj="RelatedObj"
                :AppointmentsQuery="AppointmentsQuery" :ActivitiesArray="ActivitiesArray" :CanGet="true"
                :section="section" :tab="tab" :Fields="section.Fields" :AppisDarkMode="AppisDarkMode" :CanEdit="true" :CanCreate="true" :CanDelete="true"
                />
                <DataSingleImageGallery  :EntityName="EntityName" :EntityCollectionRef="EntityCollectionRef"  :BaseStorageRef="BaseStorageRef" :EntityDataRef="EntityDataRef"
                @UpdateEditableField="UpdateEditableField"
                :SystemEntities="SystemEntities" :RelatedObj="RelatedObj"
                @OpenDialog="OpenDialog" :sectionindex="sectionindex" :tabindex="tabindex"
                :PrimaryFieldName="PrimaryFieldName" :SingleFormEditing="SingleFormEditing" @ActivateMultipleFilesUploadNotification="ActivateMultipleFilesUploadNotification"
                :Record="Record" v-if="SampleTableOption.OptionType === 'Gallery'" :AdditionalSaveMethod="AdditionalSaveMethod"
                :section="section" :tab="tab" :Fields="section.Fields" :AppisDarkMode="AppisDarkMode" :CanEdit="true"
                /> -->
                <!--TablePreview Config 
                    <SingleTabFieldsSection
                    @UpdateEditableField="UpdateEditableField"
                :SystemEntities="SystemEntities" :RelatedObj="RelatedObj"
                :sectionindex="''" :tabindex="''" :SampleOnly="true"
                :PrimaryFieldName="''" :SingleFormEditing="false"
                :Record="SampleRecord" :AdditionalSaveMethod="AdditionalSaveMethod"
                :section="''" :tab="''" :Fields="[field]" :AppisDarkMode="AppisDarkMode" :CanEdit="true"
                /> -->
            </v-card-text>
            <v-card-actions>
                <v-btn @click="CancelTableOptionDialog()">
                    Cancel
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="AddTableOption(NewTableOption)">
                    {{NewTableOption.id? 'Update '+NewTableOption.id : 'Add '+TableOptionsName}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
      <v-dialog max-width="600" v-model="NewFieldDialog">                               
        <v-card>
            <v-card-title class="overline">
                {{NewField.Type}}
            </v-card-title>
            <v-card-text v-html="NewField.Description">
            </v-card-text>
            <!-- <v-card-text> -->
                <FieldConfig @UpdateField="UpdateField" @Onepropemit="Onepropemit" @UpdateRelated="UpdateRelated"
                 :CurrentEntity="SelectedEntity" @RefreshField="RefreshField" v-if="!RefreshingNewField"
                :SystemEntities="SystemEntities" :field="NewField" :NewField="AddingNewField" :System="System"
                />
                <!-- <v-list dense>
                    <v-list-item>
                        <v-text-field :readonly="NewField.Created" v-model="NewField.Name" label="Name" />
                    </v-list-item>
                    <v-list-item>
                        <v-text-field v-model="NewField.DisplayName" label="DisplayName" />
                    </v-list-item>
                    <v-list-item dense v-if="NewField.Type === 'Option Set'">
                        <v-btn @click="Onepropemit('ActivateOptionSetDialog',NewField)">Options</v-btn>
                    </v-list-item>
                    <v-list-item dense>
                            <v-list-item-content>
                            <v-switch
                                v-model="NewField.IsMandatory"
                                class="mx-2"
                                label="Mandatory Field"
                            ></v-switch>
                            </v-list-item-content>
                            <v-list-item-content>
                                <v-switch
                                    v-model="NewField.IsSearch"
                                    class="mx-2"
                                    label="Search Field"
                                ></v-switch>
                                </v-list-item-content>
                    </v-list-item>
                        <v-list-item dense v-if="NewField.Type === 'Option Set'">
                            <v-list-item-content>
                            <v-switch
                                v-model="NewField.IsFilter"
                                class="mx-2"
                                label="Filter Field"
                            ></v-switch>
                            </v-list-item-content>
                        <v-list-item-content>
                            <v-switch
                                v-model="NewField.Secondary"
                                class="mx-2"
                                label="Secondary Field"
                            ></v-switch>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item dense v-if="NewField.Type === 'Lookup'">
                            <v-list-item-content>
                            <v-select
                                @change="UpdateRelated(NewField,NewField.RelatedBuildID)"
                                v-model="NewField.RelatedBuildID"
                                :items="LookupEntities"
                                class="mx-2"
                                item-text="id"
                                label="Related Build"
                            ></v-select>
                            </v-list-item-content>
                        </v-list-item>
                </v-list> -->
            <!-- </v-card-text> -->
            <v-card-text>
                <SingleTabFieldsSection
                    @UpdateEditableField="UpdateEditableField"
                :SystemEntities="SystemEntities" :RelatedObj="RelatedObj"
                :sectionindex="''" :tabindex="''" :SampleOnly="true" :System="System"
                :PrimaryFieldName="''" :SingleFormEditing="false" :CurrentEntity="CurrentEntity"
                :Record="SampleRecord" :AdditionalSaveMethod="AdditionalSaveMethod"
                :section="''" :tab="''" :Fields="[NewField]" :AppisDarkMode="AppisDarkMode" :CanEdit="true"
                />
            </v-card-text>
            <v-card-actions>
                <v-btn @click="CancelNewFieldDialog()">
                    Cancel
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="AddField(NewField)">
                   
                    {{AddingNewField? 'Add Field' : 'Update Field'}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-toolbar height="100" class="background" width="100%" dense style="position: fixed;z-index:3;margin-top:-20px;" v-if="Toolbar" >
       
    <v-select v-model="PageHeadersFont" label="Headers Font"                                  
        :items="FontOptions">
        <template v-slot:item="{ item }">
            <span :style="'font-family:'+item">{{item}}
                <p style="font-size:12px;">The Quick brown fox jumps over the lazy dog
                </p>
                </span>
        </template>
        <template v-slot:selection="{ item }">
            <span :style="'font-family:'+item">{{item}}</span>
        </template>
        </v-select>
        <v-select v-model="PageContentFont" label="Body Font"                                   
            :items="FontOptions">
                            <template v-slot:item="{ item }">
                                <span :style="'font-family:'+item">{{item}}
                                    <p style="font-size:12px;">The Quick brown fox jumps over the lazy dog
                                    </p>
                                    </span>
                            </template>
                            <template v-slot:selection="{ item }">
                                <span :style="'font-family:'+item">{{item}}</span>
                            </template>
                            </v-select>		
    <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-divider vertical></v-divider>
        <v-select label="Header size" v-model="PageHeadersFontSize" :items="[24,36,42,50]"									
            />
      <v-spacer></v-spacer>

      <v-btn-toggle
        color="primary"
        dense
        group
      >
      <v-dialog :width="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? '80%' : '50%'">							
                <template v-slot:activator="{ on }">	
        <v-btn
          v-on="on"
          text
        >
          <v-icon>mdi-image-edit-outline</v-icon>
        </v-btn>
          </template>
          <v-card tile flat>
          <v-text-field label="Page BG Asset" @change="Onepropemit('UpdatePageBGAsset',PageBGAsset)" clearable v-model="PageBGAsset"/>
         <v-tabs v-if="!UseGroupAssets">	
             								
                    <v-tab v-for="lib in GalleryLibraries" :key="lib.itemObjKey">									
                        {{lib.name}}									
                    </v-tab>									
                    <v-tab-item v-for="lib in GalleryLibraries" :key="lib.itemObjKey">							
                        <v-card width="800">									
                        <PhotoLibraryViewer :FullGallery="true"	:TableCollectionRef="lib.TableCollectionRef" :TableName="lib.name"							
                        @AssignImage="AssignImage" :IMGProp="'PageBGAsset'" :CurrentEntity="lib" :AppisDarkMode="true"									
                        :tab="{}" :IsThis="true" />									
                        </v-card>									
                    </v-tab-item>									
                </v-tabs>
                <v-card-text v-if="UseGroupAssets">
                                            <v-row  v-if="SystemAssets.length > 0">
                                                <v-col
                                                v-for="n in SystemAssets"
                                                :key="n.itemOvjKey"
                                                class="d-flex child-flex"
                                                cols="3"
                                                >
                                                <v-img
                                                    :src="n.ThumbURL"
                                                    aspect-ratio="1"
                                                    class="grey lighten-2"
                                                    @click="AssignImage({},'PageBGAsset',n,true)"
                                                >
                                                    <template v-slot:placeholder>
                                                    <v-row
                                                        class="fill-height ma-0"
                                                        align="center"
                                                        justify="center"
                                                    >
                                                        <v-progress-circular
                                                        indeterminate
                                                        color="grey lighten-5"
                                                        ></v-progress-circular>
                                                    </v-row>
                                                    </template>
                                                </v-img>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>
          </v-card>
      </v-dialog>
      <v-menu 									
          :close-on-content-click="false"                            									
          transition="scale-transition"                            									
          >									
          <template v-slot:activator="{ on }">	
        <v-btn
          v-on="on"
          text
        >
          <v-icon>mdi-format-color-fill</v-icon>
        </v-btn>
          </template>
          <v-list>
          <v-list-item>
            
        <v-autocomplete :items="STDCSSColors" clearable label="Page BG Color" item-text="Name" v-model="PageBGColor">
                <template v-slot:item="{ item }">
                    <span :style="'background-color:'+item.HEX">{{item.Name}}
                        <p style="font-size:12px;">The Quick brown fox jumps over the lazy dog
                        </p>
                        </span>
                </template>
            </v-autocomplete>
          </v-list-item>
          </v-list>
       </v-menu>
       <v-menu 									
          :close-on-content-click="false"                            									
          transition="scale-transition"                            									
          >									
          <template v-slot:activator="{ on }">	
        <v-btn
          v-on="on"
          text
        >
          <v-icon>mdi-eye</v-icon>
        </v-btn>
          </template>
          <v-list>
          <v-list-item>
            <v-text-field label="Page BG Gradient" @change="Onepropemit('UpdatePageBGGradient',PageBGGradient)" clearable v-model="PageBGGradient"/>
          </v-list-item>
          <v-list-item>									
            <a href="https://cssgradient.io/" target="_blank">Get Code</a>	
          </v-list-item>
          </v-list>
       </v-menu>
      </v-btn-toggle>

      <div class="mx-4"></div>

    </template>
  </v-toolbar>
      <v-expansion-panels v-if="$route.name === 'newlandingpage'" style="margin-top:45px;">	
            								
            <v-expansion-panel>									
                <v-expansion-panel-header>Page Properties									
                </v-expansion-panel-header>									
                <v-expansion-panel-content>									
                     <v-text-field v-model="PageName" label="Name" />
                     <v-text-field v-model="PageRoute" label="Route" />
                     <v-dialog  max-width="1000px" min-height="600">
                        <template v-slot:activator="{ on }">
                            <v-text-field v-model="PageIcon" v-on="on" label="Icon" />	
                        </template>
                        <v-card min-height="600">
                                <iframe width="100%" height="600" src="https://pictogrammers.github.io/@mdi/font/5.9.55/" title="Material Design Icons"></iframe>
                        </v-card>
                    </v-dialog>                     								
          <v-textarea v-model="PageOverview" label="Overview" />	
                </v-expansion-panel-content>									
            </v-expansion-panel>									
        </v-expansion-panels>    									
        									
        			<v-dialog v-model="OptionSetDialog" width="800px">									
  <v-card class="slightlypadded">									
    <v-img src='@/assets/RABaseBG.jpeg'>									
      <v-card-title class="headline blue-grey darken-2 white--text">									
                {{EditOptionSet.Name}} - Configuration <v-layout class="justify-end">									
      <v-btn fab @click="Onepropemit('SaveOptionSets',true)" icon><v-icon color="green" x-large>mdi-content-save</v-icon></v-btn><v-btn fab @click="NoPropsemit('CancelOptionSetDialog')"><v-icon color="red" x-large>mdi-window-close</v-icon></v-btn>									
      </v-layout>									
                </v-card-title>									
      <v-list>                                                									
        <v-list-item>                                      									
        <v-list-item-content>									
          <v-switch									
              v-model="EditOptionSet.Secondary"									
              class="mx-2"									
              label="Secondary Field"									
            ></v-switch>									
            </v-list-item-content>									
          <v-list-item-content>									
            <v-switch									
              v-model="EditOptionSet.IsFilter"									
              class="mx-2"									
              label="Filter Field"									
            ></v-switch>									
          </v-list-item-content>									
          <v-list-item-content>									
          <v-switch									
            v-model="EditOptionSet.IsMandatory"									
            class="mx-2"									
            label="Mandatory Field"									
          ></v-switch>									
          </v-list-item-content>                                    									
        </v-list-item>									
        </v-list>									
        <v-select item-text="Name" :items="EditOptionSet.Options" return-object v-model="EditOptionSet.DefaultOption" label="Default Option">									
        </v-select>									
  <v-layout row  color="rgb(236, 60, 126, 0.7)">									
      									
    <v-col cols="4">									
      <v-list>									
        <v-list-item>									
          <v-list-item-content class="listtitle">									
          Options									
          </v-list-item-content>									
          <v-list-item-action>									
            <v-menu 									
          :close-on-content-click="false"                            									
          transition="scale-transition"                            									
          >									
          <template v-slot:activator="{ on }">									
              <v-btn fab icon v-on="on"><v-icon>mdi-plus-thick</v-icon></v-btn>									
            </template>									
            <v-card width="400px">									
              <v-card-title>									
                New Option for {{EditOptionSet.Name}}									
                </v-card-title>									
                <v-text-field v-model="OptionName" label="Name"></v-text-field>                                                        									
                  <v-card-actions>									
                      <v-btn v-if="OptionName !== ''" @click="Onepropemit('AddOptionSetOption',OptionName)">Save</v-btn><v-btn @click="NoPropsemit('CancelGlobalOptionSetOption')">Cancel</v-btn>									
                  </v-card-actions>									
              </v-card>									
          </v-menu>									
            </v-list-item-action>									
          </v-list-item>									
        </v-list>									
        									
        <v-list>									
        <v-list-item v-for="optionsetoption in EditOptionSet.Options" :key="optionsetoption.itemObjKey" class="listoutline" @click="Onepropemit('OptionNameSelect',optionsetoption)">									
          <v-list-item-content>									
            {{optionsetoption.Name}}									
            </v-list-item-content>									
          </v-list-item>									
        </v-list>									
      </v-col>									
      <v-col>									
        <!-- <v-scroll-y-transition mode="in-out" v-if="EditOptionSet.Name"> -->									
									
            <v-card outlined  height="100%" width="100%" color="rgb(255, 255, 255, 0.9)" v-if="EditOptionSet.Name">                                									
                <v-card-title class="headline blue-grey darken-2 white--text" v-if="Option.Name">									
                Option - {{Option.Name}}									
                  <!-- <v-spacer></v-spacer>									
                  <v-switch dark									
                    v-model="Option.IsDefault"									
                    class="mx-2"									
                    label="Is Default"									
                  ></v-switch> -->									
                </v-card-title>									
                <v-card-text >									
                  <p v-if="Option.ID">Option ID: {{Option.ID}}</p>									
                  <v-text-field label="Option Name" v-model="Option.Name" v-if="Option.Name"></v-text-field>									
                  <v-layout class="justify-end" v-if="Option.Name"><v-icon @click="Onepropemit('DeleteOption',Option)" color="red">mdi-delete-forever</v-icon></v-layout>                                                       									
                </v-card-text>									
                <v-card-text v-if="typeof Option.Name === 'undefined'">									
                  Add an option to the left<span v-if="EditOptionSet.Options.length>0">, or select an existing option to change its name</span>...                                                    									
                </v-card-text>									
                                        									
            </v-card>									
                                									
            <!-- </v-scroll-y-transition> -->									
        </v-col>									
    </v-layout>									
    									
    <!-- <v-layout class="justify-end">									
      <v-btn fab @click="SaveGlobalOptionSets()" icon><v-icon color="green" x-large>mdi-content-save</v-icon></v-btn>									
      </v-layout> -->									
      <v-layout class="justify-end">
          									
      <v-btn fab @click="Threepropemit('DeleteFieldOffTabSectionANDRecordType',EditedTab,EditSection,EditOptionSet)" icon><v-icon color="red" x-large>mdi-delete-forever</v-icon></v-btn>									
      </v-layout>									
      </v-img>									
      									
    </v-card>									
  </v-dialog>									
  									
  <v-dialog v-model="EditTestimonyDialog" max-width="400" dark v-if="EditedTestimony" persistent>									
                    <v-card width="400">									
                        <v-card-text>									
                            <input type="file"  @change="Onepropemit('NewTestimonialImageFileselected',$event)"/>									
                             <v-avatar									
                            size="150"									
                            									
                            >									
                            <v-img contain v-if="!SampleTestinomialFile && EditedTestimony.Avatar"									
                                :src="EditedTestimony.Avatar"									
                                />									
                                <v-img contain v-if="SampleTestinomialFile"									
                                :src="SampleTestinomialFile"									
                                />									
                                <v-img contain v-if="!EditedTestimony.Avatar && !SampleTestinomialFile"									
                                src="@/assets/ImageHolder.png"									
                                />									
                            </v-avatar>									
                            <v-btn v-if="SampleTestinomialFile" @click="NoPropsemit('SaveTestimonialFile')">									
                                Save									
                            </v-btn>									
                        </v-card-text>									
                        <v-card-text>
                           <WriteupComponent 
                           :WriteupEditorid="EditedTestimony.Name.split(' ').join('_')+'editor'" WriteupUpdateMethod="UpdateTestimonyHTMLBox"
                           @NoPropsemit="NoPropsemit" @Onepropemit="Onepropemit" @Twopropemit="Twopropemit" @Threepropemit="Threepropemit"
                    @AssignGalleryAssets="AssignGalleryAssets" :AdvancedComputedLibraryColors="AdvancedComputedLibraryColors"
                    @AssignImage="AssignImage" :Name="TabStyleItems[ActiveButton].Name"	:UseGroupAssets="UseGroupAssets" :FrequentlyAskedQuestions="FrequentlyAskedQuestions"
                    :GalleryLibraries="GalleryLibraries"	:AppisDarkMode="AppisDarkMode"	@ActivateNewFieldDialog="ActivateNewFieldDialog"	
                    :SystemAssets="SystemAssets" :WebFormEntities="WebFormEntities" :RelatedObj="RelatedObj" :FieldTypes="FieldTypes" :TableEmbedTables="TableEmbedTables"
                    :WikiType="WikiType" :CurrentEntity="CurrentEntity" @onImportfileSelected="onImportfileSelected" @DownloadFieldsImportTemplate="DownloadFieldsImportTemplate"
                    @closeImport="closeImport" @saveImport="saveImport" @ConfigureTable="ConfigureTable" :SystemEntities="SystemEntities" :System="System"
                    @ActivateNewElement="ActivateNewElement" @ActivateTableOptionDialog="ActivateTableOptionDialog"
                    @UpdateWikiValue="UpdateWikiValue" @AssignWikiBasedGallery="AssignWikiBasedGallery" @OpenDialog="OpenDialog"
                    :EntityFieldsandFeatures="EntityFieldsandFeatures" @AssignDescriptionList="AssignDescriptionList"
                    :EditedTab="EditedTab"  :DataCountCollections="DataCountCollections" :DynamicWikiData="DynamicWikiData"   />			
                        </v-card-text>									
                        									
                        <v-card-actions>                            									
                            <v-spacer></v-spacer>									
                            <v-btn @click="NoPropsemit('CancelEditTestimony')">Close</v-btn>									
                        </v-card-actions>									
                    </v-card>									
                </v-dialog>									
                <v-dialog v-model="FieldsDialogActivate" v-if="EditedTab" max-width="400" dark>									
                    <v-card width="400">									
                        <v-card-title>									
                            {{EditedTab.FormName}}									
                        </v-card-title>									
                        <v-list dense v-if="!EditedTab.RelatedEntity">									
                            <v-btn @click="NoPropsemit('AddFieldtoWebForm')">Add Field</v-btn>									
                            									
                            <v-list-item v-for="field in EditedTab.FormFields" :key="field.itemObjKey">									
                                <v-list-item-content>									
                                <v-text-field label="Field Name" v-model="field.Name"></v-text-field>									
                                </v-list-item-content>									
                                <v-list-item-content>									
                                <v-select label="Field Type" :items="['Single Line Text','Multiple Lines Text','Option Set','Single File Upload','Number Field','Date']" v-model="field.Type"></v-select>									
                                </v-list-item-content>									
                                </v-list-item>            									
                            </v-list>	
                            <v-list dense v-if="EditedTab.RelatedEntity">
                            <v-list-item  @drop.prevent="Twopropemit('formfielddragfinish',EditedTab,fieldindex)"	@dragover.prevent								
                            :draggable="true" @dragstart="Twopropemit('formfielddragstart',field,fieldindex)" v-for="(field,fieldindex) in EditedTab.FormFields" :key="field.itemObjKey">
                                <v-list-item-action>
                                    <v-icon>mdi-drag</v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title>
                                      {{field.DisplayName}}     
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        {{field.Type}}
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>    									
                            </v-list>								
                        <v-card-actions>									
                            <!-- <v-btn>Cancel</v-btn>									 -->
                            <v-spacer></v-spacer>									
                            <v-btn @click="NoPropsemit('FormFieldsDialogDeactive')">Close</v-btn>									
                        </v-card-actions>									
                    </v-card>									
                </v-dialog>		
                					
               
                <v-dialog persistent :width="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? '80%' : '50%'" hide-overlay v-if="EditedTab && OldStyle" v-model="TabDialogOldStyle">
      
                    <v-toolbar prominent  class="recordtoolbar " width="100%" dense v-if="TabDialog && EditedTab && OldStyle" >
                        <v-card-title class="mediumoverline">
                       {{EditedTab.DataViewName? EditedTab.DataViewName : EditedTab.Name}}
                        </v-card-title>
                        <v-spacer>
                         </v-spacer>
                         <v-toolbar-title class="justify-center">
                             <v-select class="hidden-md-and-up"
                             :items="TabStyleItems" v-model="ActiveButton" item-text="Index"
                             >

                             </v-select>
                           <v-btn-toggle class="hidden-sm-and-down"
                        v-model="ActiveButton"
                        >
                            <v-btn v-for="btn in FilteredTabStyleItems" :key="btn.itemObjKey">
                            <v-icon>{{btn.Icon}}</v-icon>
                            </v-btn>
                        </v-btn-toggle>
                         </v-toolbar-title>
                         <v-spacer>
                         </v-spacer>
                         <v-card-title>
                        <v-icon class="justify-end soloactionicon" @click="DeactivateTabDialog()">mdi-close</v-icon> 									
                         <v-icon class="justify-end soloactionicon" color="red" @click="NoPropsemit('DeleteTab')">mdi-delete-forever</v-icon>
                        </v-card-title>
                        
                    </v-toolbar>
                 
                    <v-card-text class="background" v-if="TabStyleItems[ActiveButton]">
                         <v-expansion-panel v-if="EditedTab.Name === 'blank' && !EditedTab.SectionType">									
                      <v-expansion-panel-header>									
                           <v-autocomplete :items="RenderedContentBlocks" v-model="TypeChange" :item-text="BlockNameProp" label="Type" @change="Twopropemit('ChangeContentType',EditedTab,TypeChange)" return-object >
                              <template v-slot:item="{ item }">
                               <v-icon small>{{item.Icon}}</v-icon> {{ item.DataViewName ? item.DataViewName : item.Name }}
                            </template>
                          </v-autocomplete>									
                      </v-expansion-panel-header>	
                      </v-expansion-panel>
                     
                        <!-- anything DataviewName-->
                        <!-- :is="TabStyleItems[ActiveButton].compname"  now ActiveButtoncompname
                        :Name="TabStyleItems[ActiveButton].Name" now ActiveButtonName-->
                    <component :is="TabStyleItems[ActiveButton].compname" :RenderedContentBlocks="RenderedContentBlocks"
                    @ToggleElementAnimationDialog="ToggleElementAnimationDialog"
                    :WriteupEditorid="EditedTab.Name.split(' ').join('_')+EditedTabindex+'_editor'" WriteupUpdateMethod="UpdateHTMLBox"
                    @NoPropsemit="NoPropsemit" @Onepropemit="Onepropemit" @Twopropemit="Twopropemit" @Threepropemit="Threepropemit"
                    @AssignGalleryAssets="AssignGalleryAssets" :AdvancedComputedLibraryColors="AdvancedComputedLibraryColors" :FrequentlyAskedQuestions="FrequentlyAskedQuestions"
                    @AssignImage="AssignImage" :Name="TabStyleItems[ActiveButton].Name"	:UseGroupAssets="UseGroupAssets"
                    :FontOptions="FontOptions" :GalleryLibraries="GalleryLibraries"	:AppisDarkMode="AppisDarkMode"	@ActivateNewFieldDialog="ActivateNewFieldDialog"	
                    :SystemAssets="SystemAssets" :WebFormEntities="WebFormEntities" :RelatedObj="RelatedObj" :FieldTypes="FieldTypes" :TableEmbedTables="TableEmbedTables"
                    :WikiType="WikiType" :CurrentEntity="CurrentEntity" @onImportfileSelected="onImportfileSelected" @DownloadFieldsImportTemplate="DownloadFieldsImportTemplate"
                    @closeImport="closeImport" @saveImport="saveImport" @ConfigureTable="ConfigureTable" :SystemEntities="SystemEntities" :System="System"
                    @ActivateNewElement="ActivateNewElement" @ActivateTableOptionDialog="ActivateTableOptionDialog"
                    @UpdateWikiValue="UpdateWikiValue" @AssignWikiBasedGallery="AssignWikiBasedGallery" @OpenDialog="OpenDialog"
                    :EntityFieldsandFeatures="EntityFieldsandFeatures" @AssignDescriptionList="AssignDescriptionList"
                    :EditedTab="EditedTab"  :DataCountCollections="DataCountCollections" :DynamicWikiData="DynamicWikiData"   />
                    </v-card-text>
                   
                </v-dialog>		
                <v-navigation-drawer width="300" class="elevation-4" v-model="TabDialog" v-if="ActiveButtoncompname && ActiveButtonName && TabDialog || TypeSelection && TabDialog" bottom right :style="NavStyle">
                    <v-card-subtitle  class="background darken-1 mediumoverline" style="position: absolute;z-index: 100;width:100%;">
                        {{ActiveButtonName}}
                    </v-card-subtitle>
                   
                    <v-btn style="position: absolute;right: 50px;;z-index:101;" fab icon>
                    <v-icon   @click="DeactivateTabDialog()" >mdi-close</v-icon>
                    </v-btn>
                    <v-btn  style="position: absolute;right: 0px;z-index:101;" fab icon>
                    <v-icon class="red--text"  @click="NoPropsemit('DeleteTab')" >mdi-delete-forever</v-icon>
                    </v-btn>
                   
                    <component :is="ActiveButtoncompname" :RenderedContentBlocks="RenderedContentBlocks" style="height: 100%;"
                     @ToggleElementAnimationDialog="ToggleElementAnimationDialog"
                            :WriteupEditorid="EditedTab.Name ? EditedTab.Name.split(' ').join('_')+EditedTabindex+'_editor' : ''" WriteupUpdateMethod="UpdateHTMLBox"
                            @NoPropsemit="NoPropsemit" @Onepropemit="Onepropemit" @Twopropemit="Twopropemit" @Threepropemit="Threepropemit"
                            @AssignGalleryAssets="AssignGalleryAssets" :AdvancedComputedLibraryColors="AdvancedComputedLibraryColors" :FrequentlyAskedQuestions="FrequentlyAskedQuestions"
                            @AssignImage="AssignImage" :Name="ActiveButtonName"	:UseGroupAssets="UseGroupAssets"
                            :FontOptions="FontOptions" :GalleryLibraries="GalleryLibraries"	:AppisDarkMode="AppisDarkMode"	@ActivateNewFieldDialog="ActivateNewFieldDialog"	
                            :SystemAssets="SystemAssets" :WebFormEntities="WebFormEntities" :RelatedObj="RelatedObj" :FieldTypes="FieldTypes" :TableEmbedTables="TableEmbedTables"
                            :WikiType="WikiType" :CurrentEntity="CurrentEntity" @onImportfileSelected="onImportfileSelected" @DownloadFieldsImportTemplate="DownloadFieldsImportTemplate"
                            @closeImport="closeImport" @saveImport="saveImport" @ConfigureTable="ConfigureTable" :SystemEntities="SystemEntities" :System="System"
                            @ActivateNewElement="ActivateNewElement" @ActivateTableOptionDialog="ActivateTableOptionDialog"
                            @UpdateWikiValue="UpdateWikiValue" @AssignWikiBasedGallery="AssignWikiBasedGallery" @OpenDialog="OpenDialog"
                            :EntityFieldsandFeatures="EntityFieldsandFeatures" @AssignDescriptionList="AssignDescriptionList" :GroupData="GroupData"
                            :EditedTab="EditedTab"  :DataCountCollections="DataCountCollections" :DynamicWikiData="DynamicWikiData"  v-if="!TypeSelection" />   

                    <v-expansion-panel v-if="TypeSelection">									
                      <v-expansion-panel-header>									
                           <v-autocomplete :items="RenderedContentBlocks" v-model="TypeChange" :item-text="BlockNameProp" label="Type" @change="Twopropemit('ChangeContentType',EditedTab,TypeChange)" return-object >
                              <template v-slot:item="{ item }">
                               <v-icon small>{{item.Icon}}</v-icon> {{ item.DataViewName ? item.DataViewName : item.Name }}
                            </template>
                          </v-autocomplete>									
                      </v-expansion-panel-header>	
                      </v-expansion-panel>      
                </v-navigation-drawer>
               <v-list height="100%" style="position: fixed;top: 30%;right: 0px;z-index:30;" class="transparent">
                          <v-list-item v-for="btn in FilteredTabStyleItems" :key="btn.itemObjKey">
                        <v-btn @click="Twopropemit('ActivateStyleButton',btn,EditedTab)">
                            <v-icon>{{btn.Icon}}</v-icon>
                        </v-btn>
                          </v-list-item>
                      </v-list>          
            <v-layout column class="fab-container"
            v-if="$route.name !== 'GroupPageEditor' && $route.name !== 'PageEditor'"
            >									
                <v-btn  icon x-large @click="SavePage(PublishType,PageName,PageRoute,PageOverview,PageContentFont,PageHeadersFontSize,PageHeadersFont,PageIcon,PageBGGradient,PageBGAsset,PageBGColor)"><v-icon  color="green" x-large>mdi-content-save</v-icon></v-btn>									
                    <!-- <v-btn  icon x-large @click="ContentTypesDialog = !ContentTypesDialog"><v-icon  color="purple" x-large>mdi-monitor-dashboard</v-icon></v-btn>									
                    <v-btn  v-if="$route.name === 'newlandingpage'" icon x-large :to="'/LandingPage/'+this.$route.params.id"><v-icon  color="blue" x-large>mdi-eye</v-icon></v-btn>									 -->
            </v-layout>	
  </div>
</template>

<script>

import WikiSourceEditor from '@/components/SuitePlugins/Wiki/WikiSourceEditor';
import FieldConfig from '@/components/Database/FieldConfig';	
import TableEmbedTab from '@/components/WebPages/RenderComponents/TableEmbedTab';	
import SingleTabFieldsSection from '@/components/Database/SingleTabFieldsSection';
import PhotoLibraryViewer from '@/components/SuitePlugins/PhotoLibrary/PhotoLibraryViewer';
import WriteupComponent from '@/components/WebPages/ConfigComponents/WriteupComponent';
import ImageConfiguringComponent from '@/components/WebPages/ConfigComponents/ImageConfiguringComponent';
import ActionButtonConfiguringComponent from '@/components/WebPages/ConfigComponents/ActionButtonConfiguringComponent';
import TitleConfiguringComponent from '@/components/WebPages/ConfigComponents/TitleConfiguringComponent';
import WavesConfigComponent from '@/components/WebPages/ConfigComponents/WavesConfigComponent';
import BoxStylingComponent from '@/components/WebPages/ConfigComponents/BoxStylingComponent';
import AdvancedOptionsComponent from '@/components/WebPages/ConfigComponents/AdvancedOptionsComponent';
import ElementSizingOptionsComponent from '@/components/WebPages/ConfigComponents/ElementSizingOptionsComponent';
import TestimonialsComponent from '@/components/WebPages/ConfigComponents/TestimonialsComponent';
import GalAssetsComponent from '@/components/WebPages/ConfigComponents/GalAssetsComponent';
import BoxWrappingComponent from '@/components/WebPages/ConfigComponents/BoxWrappingComponent';
import MarginStylingComponent from '@/components/WebPages/ConfigComponents/MarginStylingComponent';
import SocialConfigFeedComponent from '@/components/WebPages/ConfigComponents/SocialConfigFeedComponent';
import BasicContentConfigComponent from '@/components/WebPages/ConfigComponents/BasicContentConfigComponent';
import ItemsComponent from '@/components/WebPages/ConfigComponents/ItemsComponent';
import DescriptionListConfigComponent from '@/components/WebPages/ConfigComponents/DescriptionListConfigComponent';
import DataTableCallsComponent from '@/components/WebPages/ConfigComponents/DataTableCallsComponent';
import ClippingConfigurationComponent from '@/components/WebPages/ConfigComponents/ClippingConfigurationComponent';
import BasicDataViewTypesConfigComponent from '@/components/WebPages/ConfigComponents/BasicDataViewTypesConfigComponent';
import BasicDataViewTitleConfigComponent from '@/components/WebPages/ConfigComponents/BasicDataViewTitleConfigComponent';
import SectionTypeAddChildComponent from '@/components/WebPages/ConfigComponents/SectionTypeAddChildComponent';

export default {
    props: ['LoadedPageBGGradient','LoadedPageBGAsset','LoadedPageBGColor','GroupData','SelectedActiveButton',
        'LoadedPageName','LoadedPageRoute','LoadedPageIcon','LoadedPageOverview','LoadedPublishType','LoadedPageContentFont','LoadedPageHeadersFontSize','LoadedPageHeadersFont','SystemGuides',
        'OptionSetDialog','TabDialog','EditedTab','EditedTabindex','SystemAssets','System','DynamicWikiData','FeatureNavList','ClsfdNavList','FrequentlyAskedQuestions',
    'EditOptionSet','Option','ContentTypesDialog','OptionName','FieldsDialogActivate','PageTabs','SampleTestinomialFile','EditedTestimony','SystemAssetsPage','FieldTypes','SystemEntities','CurrentEntity','TypeChange',
    'EntityCollectionRef','EntityDataRef','RelatedObj','SitePages','SystemPhotoLibraries','GalleryLibraries','WikiEntities','TableRecordView'],
    components: {SingleTabFieldsSection,TableEmbedTab,FieldConfig,WikiSourceEditor,PhotoLibraryViewer,
    WriteupComponent,ImageConfiguringComponent,ActionButtonConfiguringComponent,TitleConfiguringComponent,WavesConfigComponent,BoxStylingComponent,
    AdvancedOptionsComponent,ElementSizingOptionsComponent,TestimonialsComponent,GalAssetsComponent,BoxWrappingComponent,
    MarginStylingComponent,SocialConfigFeedComponent,BasicContentConfigComponent,ItemsComponent,DescriptionListConfigComponent,BasicDataViewTypesConfigComponent,BasicDataViewTitleConfigComponent,
    DataTableCallsComponent,ClippingConfigurationComponent,SectionTypeAddChildComponent},
    data(){
        return {
            ActiveButtoncompname: '',
            ActiveButtonName: '',
            ActiveButton: 0,
            Toolbar: false,
            STDCSSColors: [{Name: 'aliceblue', HEX: '#f0f8ff'},{Name: 'antiquewhite', HEX: '#faebd7'},{Name: 'aqua', HEX: '#00ffff'},{Name: 'aquamarine', HEX: '#7fffd4'},{Name: 'azure', HEX: '#f0ffff'},{Name: 'beige', HEX: '#f5f5dc'},{Name: 'bisque', HEX: '#ffe4c4'},{Name: 'black', HEX: '#000000'},{Name: 'blanchedalmond', HEX: '#ffebcd'},{Name: 'blue', HEX: '#0000ff'},{Name: 'blueviolet', HEX: '#8a2be2'},{Name: 'brown', HEX: '#a52a2a'},{Name: 'burlywood', HEX: '#deb887'},{Name: 'cadetblue', HEX: '#5f9ea0'},{Name: 'chartreuse', HEX: '#7fff00'},{Name: 'chocolate', HEX: '#d2691e'},{Name: 'coral', HEX: '#ff7f50'},{Name: 'cornflowerblue', HEX: '#6495ed'},{Name: 'cornsilk', HEX: '#fff8dc'},{Name: 'crimson', HEX: '#dc143c'},{Name: 'cyan', HEX: '#00ffff'},{Name: 'darkblue', HEX: '#00008b'},{Name: 'darkcyan', HEX: '#008b8b'},{Name: 'darkgoldenrod', HEX: '#b8860b'},{Name: 'darkgray', HEX: '#a9a9a9'},{Name: 'darkgreen', HEX: '#006400'},{Name: 'darkgrey', HEX: '#a9a9a9'},{Name: 'darkkhaki', HEX: '#bdb76b'},{Name: 'darkmagenta', HEX: '#8b008b'},{Name: 'darkolivegreen', HEX: '#556b2f'},{Name: 'darkorange', HEX: '#ff8c00'},{Name: 'darkorchid', HEX: '#9932cc'},{Name: 'darkred', HEX: '#8b0000'},{Name: 'darksalmon', HEX: '#e9967a'},{Name: 'darkseagreen', HEX: '#8fbc8f'},{Name: 'darkslateblue', HEX: '#483d8b'},{Name: 'darkslategray', HEX: '#2f4f4f'},{Name: 'darkslategrey', HEX: '#2f4f4f'},{Name: 'darkturquoise', HEX: '#00ced1'},{Name: 'darkviolet', HEX: '#9400d3'},{Name: 'deeppink', HEX: '#ff1493'},{Name: 'deepskyblue', HEX: '#00bfff'},{Name: 'dimgray', HEX: '#696969'},{Name: 'dimgrey', HEX: '#696969'},{Name: 'dodgerblue', HEX: '#1e90ff'},{Name: 'firebrick', HEX: '#b22222'},{Name: 'floralwhite', HEX: '#fffaf0'},{Name: 'forestgreen', HEX: '#228b22'},{Name: 'fuchsia', HEX: '#ff00ff'},{Name: 'gainsboro', HEX: '#dcdcdc'},{Name: 'ghostwhite', HEX: '#f8f8ff'},{Name: 'gold', HEX: '#ffd700'},{Name: 'goldenrod', HEX: '#daa520'},{Name: 'gray', HEX: '#808080'},{Name: 'green', HEX: '#008000'},{Name: 'greenyellow', HEX: '#adff2f'},{Name: 'grey', HEX: '#808080'},{Name: 'honeydew', HEX: '#f0fff0'},{Name: 'hotpink', HEX: '#ff69b4'},{Name: 'indianred', HEX: '#cd5c5c'},{Name: 'indigo', HEX: '#4b0082'},{Name: 'ivory', HEX: '#fffff0'},{Name: 'khaki', HEX: '#f0e68c'},{Name: 'lavender', HEX: '#e6e6fa'},{Name: 'lavenderblush', HEX: '#fff0f5'},{Name: 'lawngreen', HEX: '#7cfc00'},{Name: 'lemonchiffon', HEX: '#fffacd'},{Name: 'lightblue', HEX: '#add8e6'},{Name: 'lightcoral', HEX: '#f08080'},{Name: 'lightcyan', HEX: '#e0ffff'},{Name: 'lightgoldenrodyellow', HEX: '#fafad2'},{Name: 'lightgray', HEX: '#d3d3d3'},{Name: 'lightgreen', HEX: '#90ee90'},{Name: 'lightgrey', HEX: '#d3d3d3'},{Name: 'lightpink', HEX: '#ffb6c1'},{Name: 'lightsalmon', HEX: '#ffa07a'},{Name: 'lightseagreen', HEX: '#20b2aa'},{Name: 'lightskyblue', HEX: '#87cefa'},{Name: 'lightslategray', HEX: '#778899'},{Name: 'lightslategrey', HEX: '#778899'},{Name: 'lightsteelblue', HEX: '#b0c4de'},{Name: 'lightyellow', HEX: '#ffffe0'},{Name: 'lime', HEX: '#00ff00'},{Name: 'limegreen', HEX: '#32cd32'},{Name: 'linen', HEX: '#faf0e6'},{Name: 'magenta', HEX: '#ff00ff'},{Name: 'maroon', HEX: '#800000'},{Name: 'mediumaquamarine', HEX: '#66cdaa'},{Name: 'mediumblue', HEX: '#0000cd'},{Name: 'mediumorchid', HEX: '#ba55d3'},{Name: 'mediumpurple', HEX: '#9370db'},{Name: 'mediumseagreen', HEX: '#3cb371'},{Name: 'mediumslateblue', HEX: '#7b68ee'},{Name: 'mediumspringgreen', HEX: '#00fa9a'},{Name: 'mediumturquoise', HEX: '#48d1cc'},{Name: 'mediumvioletred', HEX: '#c71585'},{Name: 'midnightblue', HEX: '#191970'},{Name: 'mintcream', HEX: '#f5fffa'},{Name: 'mistyrose', HEX: '#ffe4e1'},{Name: 'moccasin', HEX: '#ffe4b5'},{Name: 'navajowhite', HEX: '#ffdead'},{Name: 'navy', HEX: '#000080'},{Name: 'oldlace', HEX: '#fdf5e6'},{Name: 'olive', HEX: '#808000'},{Name: 'olivedrab', HEX: '#6b8e23'},{Name: 'orange', HEX: '#ffa500'},{Name: 'orangered', HEX: '#ff4500'},{Name: 'orchid', HEX: '#da70d6'},{Name: 'palegoldenrod', HEX: '#eee8aa'},{Name: 'palegreen', HEX: '#98fb98'},{Name: 'paleturquoise', HEX: '#afeeee'},{Name: 'palevioletred', HEX: '#db7093'},{Name: 'papayawhip', HEX: '#ffefd5'},{Name: 'peachpuff', HEX: '#ffdab9'},{Name: 'peru', HEX: '#cd853f'},{Name: 'pink', HEX: '#ffc0cb'},{Name: 'plum', HEX: '#dda0dd'},{Name: 'powderblue', HEX: '#b0e0e6'},{Name: 'purple', HEX: '#800080'},{Name: 'red', HEX: '#ff0000'},{Name: 'rosybrown', HEX: '#bc8f8f'},{Name: 'royalblue', HEX: '#4169e1'},{Name: 'saddlebrown', HEX: '#8b4513'},{Name: 'salmon', HEX: '#fa8072'},{Name: 'sandybrown', HEX: '#f4a460'},{Name: 'seagreen', HEX: '#2e8b57'},{Name: 'seashell', HEX: '#fff5ee'},{Name: 'sienna', HEX: '#a0522d'},{Name: 'silver', HEX: '#c0c0c0'},{Name: 'skyblue', HEX: '#87ceeb'},{Name: 'slateblue', HEX: '#6a5acd'},{Name: 'slategray', HEX: '#708090'},{Name: 'slategrey', HEX: '#708090'},{Name: 'snow', HEX: '#fffafa'},{Name: 'springgreen', HEX: '#00ff7f'},{Name: 'steelblue', HEX: '#4682b4'},{Name: 'tan', HEX: '#d2b48c'},{Name: 'teal', HEX: '#008080'},{Name: 'thistle', HEX: '#d8bfd8'},{Name: 'tomato', HEX: '#ff6347'},{Name: 'turquoise', HEX: '#40e0d0'},{Name: 'violet', HEX: '#ee82ee'},{Name: 'wheat', HEX: '#f5deb3'},{Name: 'white', HEX: '#ffffff'},{Name: 'whitesmoke', HEX: '#f5f5f5'},{Name: 'yellow', HEX: '#ffff00'},{Name: 'yellowgreen', HEX: '#9acd32'},
],
            PageBGGradient: '',
            PageBGAsset: '',
            PageBGColor: '',
            LibrariesDialog: false,
            LibraryColors: [
        'red',
        'white',
        'black',
        'pink',
        'purple',
        'indigo',
        'blue',
        'light-blue',
        'cyan',
        'teal',
        'green',
        'light-green',
        'lime',
        'yellow',
        'amber',
        'orange',
        'deep-orange',
        'brown',
        'blue-grey',
        'grey'
      ],
            WrappingOptions: [
            {
                DisplayName: 'Top Left',
                FlexValue: 'align-self:flex-start',
                LayoutValue: 'fill-height justify-start',
                JustifyIcon: 'mdi-format-align-left'
            },
            {
                DisplayName: 'Top Center',
                FlexValue: 'align-self:flex-start',
                LayoutValue: 'fill-height justify-center',
                JustifyIcon: 'mdi-format-align-center'
            },
            {
                DisplayName: 'Top Right',
                FlexValue: 'align-self:flex-start',
                LayoutValue: 'fill-height justify-end',
                JustifyIcon: 'mdi-format-align-right'
            },
            {
                DisplayName: 'Center Left',
                FlexValue: 'align-self:center',
                LayoutValue: 'fill-height justify-start',
                JustifyIcon: 'mdi-format-align-left'
            },
            {
                DisplayName: 'Absolute Center',
                FlexValue: 'align-self:center',
                LayoutValue: 'fill-height justify-center',
                JustifyIcon: 'mdi-format-align-center'
            },
            {
                DisplayName: 'Center Right',
                FlexValue: 'align-self:center',
                LayoutValue: 'fill-height justify-end',
                JustifyIcon: 'mdi-format-align-right'
            },
            {
                DisplayName: 'Bottom Left',
                FlexValue: 'align-self:flex-end',
                LayoutValue: 'fill-height justify-start',
                JustifyIcon: 'mdi-format-align-left'
            },
            {
                DisplayName: 'Bottom Center',
                FlexValue: 'align-self:flex-end',
                LayoutValue: 'fill-height justify-center',
                JustifyIcon: 'mdi-format-align-center'
            },
            {
                DisplayName: 'Bottom Right',
                FlexValue: 'align-self:flex-end',
                LayoutValue: 'fill-height justify-end',
                JustifyIcon: 'mdi-format-align-right'
            },
            
        ],
            ListPanel: '',
            WikiProperties: ['WikiFields','HideIMG','IMGField','HideDescription','DescriptionField','TaggedFields','ShowPrice','PriceField','TitleField','HideTitle','TagField'],
            WikiBooleanProperties: ['HideIMG','HideDescription','ShowPrice','HideTitle'],
            NewWikiFieldDialog: false,
            NewFieldName: '',
            NewfieldType: '',
            WikiSourceDialog: false,
            rules: {
            telnr: value => {
              const pattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
              return pattern.test(value) || "Not a telephone number.";
            },
            min8Chars: value => value.length >= 8 || "Min. 8 characters",
            required: value => !!value || "Required.",
            email: value => {
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              return pattern.test(value) || "Invalid e-mail.";
            },
            url: value => {
              const urlpattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); 
              return urlpattern.test(value) || "Invalid Link.";
            }
          },
            PublishType: '',									
            PublishTypes: [									
                'Public',									
                'Members Only'									
            ],
            PageOverview: '',	
            PageIcon: '',								
            PageName: '',
            PageRoute: '',
            PageContentFont: 'Montserrat',									
            PageHeadersFontSize: 42,									
            PageHeadersFont: 'Raleway',	importdialog: false,
            ImportFile: '',
            ImportHeaders: [
                { text: 'Name', value: 'Name'},
                { text: 'DisplayName', value: 'DisplayName'},
                { text: 'Type', value: 'Type'},
                { text: 'CommonFieldType', value: 'CommonFieldType'},
                { text: 'LookupTable', value: 'LookupTable'},        
                { text: 'dud', value: 'dud'},
            ],
            ImportFileSessionName: '',
            NewImportsArray: [],
            PartialFailuresArray: [],
            TypeChange: '',
            RefreshingNewField: false,
            NewField: '',
            AddingNewField: false,
            NewTableOption: '',
            SampleTableOption: '',
            NewTableOptionDialog: false,
            NewFieldDialog: false,
            SampleRecord: {},
            TableoptionsSearch: '',
            NewTableOptionSearch: '',
            ExistingFieldSearch: '',
            ExistingFormFieldSearch: '',
            NewFieldSearch: '',
            ContentBlocks: [									
            {	
                StaticVariables: [],	
                Category: 'Custom',							
            Open: true,									
            SectionType: true,									
            Transparent: true,									
            Alignment: 'center',									
            Justify: 'justify-center',									
            RowTransparency: 'transparent',									
            Name: 'blank',									
            Elements: [],									
            ShowComponents: true,									
            FlexXLRG:11,									
            FlexLarge: 11,									
            FlexMedium: 11,									
            FlexSmall: 12,									
            FlexXSmall: 12,									
            },	
            {
            StaticVariables: ['DataContent','Title','Description','Icon'],		
            Category: 'Links',
            Open: true,
            Transparent: true,
            Alignment: 'center',
            Justify: 'justify-center',
            RowTransparency: 'transparent',
            Name: 'Card Link',
            Type: 'Card Link',
            DisplayName: 'Card Link',
            HasImage: true,
            DataContent: {
                Name: 'Name of Data Link',
                dataseticon: 'mdi-eye',
                ContentLinkName: 'Somehwere',
                ContentLinkType: 'Build',
                ContentIcon: 'mdi-eye'
            },
            HasAlignment: true,
            Elements: [],
            RowColor: '#00ffff',
            ShowComponents: true,
            Icon: 'mdi-link-box',
            Title: 'About',
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,
            MarginTop: 0,
            MarginBottom: 0,
            MarginLeft: 0,
            MarginRight: 0,
            BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },
            FontColor :{
                    hex: '#000000'
            },
            HeaderColor: {
                hex: '#000000'
            },
            FlexXLRG:9,
            FlexLarge: 9,
            FlexMedium: 11,
            FlexSmall: 11,
            FlexXSmall: 10,
            Cols: 12,
            },			
            {
            StaticVariables: ['InfoCards','Title','Description','Icon'],	
            Category: 'Misc',
            Open: true,
            Transparent: true,
            Alignment: 'center',
            Justify: 'justify-center',
            RowTransparency: 'transparent',
            Name: 'Info Card',
            Type: 'Info Card',
            DisplayName: 'Info Card',
            InfoCards: [],
            HasAlignment: true,
            Elements: [],
            RowColor: '#00ffff',
            ShowComponents: true,
            Icon: 'mdi-id-card',
            Title: 'About',
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,
            MarginTop: 0,
            MarginBottom: 0,
            MarginLeft: 0,
            MarginRight: 0,
            CardsColor: {
                hex: '#ffffff'
            },
            ChipsOutline: {
                hex: '#ff0000'
            },
            BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },
            FontColor :{
                    hex: '#000000'
            },
            HeaderColor: {
                hex: '#000000'
            },
            CardsShaped: true,
            CardsFlat: false,
            CardsOutlined: false,
            CardsTile: false,
            CardsElevation: 4,
            HeaderShaped: true,
            HeaderFlat: false,
            HeaderOutlined: false,
            HeaderTile: false,
            HeaderElevation: 4,
            FlexXLRG:9,
            FlexLarge: 9,
            FlexMedium: 11,
            FlexSmall: 11,
            FlexXSmall: 10,
            Cols: 12,
            },
            
            {
                StaticVariables: [],
            Category: 'Feeds',
            Open: true,
            Transparent: true,
            Alignment: 'center',
            Justify: 'justify-center',
            RowTransparency: 'transparent',
            SocialComponent: true,
            PublicPages: false,
            // SocialCompBoolean: 'Site_Has_Blogs',
            Name: 'System Activities',
            Type: 'System Activities',
            DisplayName: 'System Activities',
            HasAlignment: true,
            Elements: [],
            RowColor: '#00ffff',
            ShowComponents: true,
            Icon: 'mdi-timetable',
            Title: 'About',
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,
            MarginTop: 0,
            MarginBottom: 0,
            MarginLeft: 0,
            MarginRight: 0,
            BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },
            FontColor :{
                    hex: '#000000'
            },
            HeaderColor: {
                hex: '#000000'
            },
            FlexXLRG:9,
            FlexLarge: 9,
            FlexMedium: 11,
            FlexSmall: 11,
            FlexXSmall: 10,
            Cols: 12,
            },
            
            {
                StaticVariables: [],
            Category: 'Feeds',
            Open: true,
            Transparent: true,
            Alignment: 'center',
            Justify: 'justify-center',
            RowTransparency: 'transparent',
            Name: 'Social Site Posts',
            Type: 'Social Posts',
            DisplayName: 'Social Site Posts',
            HasAlignment: true,
            Elements: [],
            RowColor: '#00ffff',
            ShowComponents: true,
            Icon: 'mdi-language-html5',
            Title: 'About',
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,
            MarginTop: 0,
            MarginBottom: 0,
            MarginLeft: 0,
            MarginRight: 0,
            BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },
            FontColor :{
                    hex: '#000000'
            },
            HeaderColor: {
                hex: '#000000'
            },
            FlexXLRG:9,
            FlexLarge: 9,
            FlexMedium: 11,
            FlexSmall: 11,
            FlexXSmall: 10,
            Cols: 12,
            },
            //nothing on groups yet
            // {
            // Open: true,
            // Transparent: true,
            // Alignment: 'center',
            // Justify: 'justify-center',
            // RowTransparency: 'transparent',
            // Name: 'Groups Feed',
            // Type: 'Groups Feed',
            // DisplayName: 'Groups Feed',
            // HasAlignment: true,
            // Elements: [],
            // RowColor: '#00ffff',
            // ShowComponents: true,
            // Icon: 'mdi-language-html5',
            // Title: 'About',
            // Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,
            // MarginTop: 0,
            // MarginBottom: 0,
            // MarginLeft: 0,
            // MarginRight: 0,
            // BGColor: {
            //         hex: '#ffffff',
            //         hexa: '#ffffffff'
            // },
            // FontColor :{
            //         hex: '#000000'
            // },
            // HeaderColor: {
            //     hex: '#000000'
            // },
            // FlexXLRG:9,
            // FlexLarge: 9,
            // FlexMedium: 11,
            // FlexSmall: 11,
            // FlexXSmall: 10,
            // Cols: 12,
            // },
            
            {
                StaticVariables: [],
            Category: 'Feeds',
            Open: true,
            Transparent: true,
            Alignment: 'center',
            Justify: 'justify-start',
            RowTransparency: 'transparent',
            SocialComponent: true,
            SocialCompPluginid: 'Site_Articles',
            SocialCompPublicBoolean: 'Site_Articles_Public',
            GroupParamsProp: 'ArticlesPrivacy',
            PublicPages: false,
            Name: 'Site Articles',
            Type: 'Site Articles',
            DisplayName: 'Site Articles',
            HasAlignment: true,
            SliderView: true,
            Excerpt: 250,
            Slice: 6,
            TypeCategories: [],
            Elements: [],
            RowColor: '#00ffff',
            ShowComponents: true,
            Icon: 'mdi-newspaper',
            Title: 'About',
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,
            MarginTop: 0,
            MarginBottom: 0,
            MarginLeft: 0,
            MarginRight: 0,
            BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },
            FontColor :{
                    hex: '#000000'
            },
            HeaderColor: {
                hex: '#000000'
            },
            FlexXLRG:9,
            FlexLarge: 9,
            FlexMedium: 11,
            FlexSmall: 11,
            FlexXSmall: 10,
            Cols: 12,
            },
            {
                StaticVariables: [],
            Category: 'Feeds',
            Open: true,
            Transparent: true,
            Alignment: 'center',
            Justify: 'justify-start',
            RowTransparency: 'transparent',
            SocialComponent: true,
            SocialCompPluginid: 'Site_Groups',
            SocialCompPublicBoolean: 'Site_Has_Groups',
            PublicPages: false,
            Name: 'Site Groups',
            Type: 'Site Groups',
            DisplayName: 'Site Groups',
            HasAlignment: true,
            SliderView: true,
            Excerpt: 250,
            Slice: 6,
            TypeCategories: [],
            Elements: [],
            RowColor: '#00ffff',
            ShowComponents: true,
            Icon: 'mdi-account-group',
            Title: '',
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,
            MarginTop: 0,
            MarginBottom: 0,
            MarginLeft: 0,
            MarginRight: 0,
            BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },
            FontColor :{
                    hex: '#000000'
            },
            HeaderColor: {
                hex: '#000000'
            },
            FlexXLRG:12,
            FlexLarge: 12,
            FlexMedium: 12,
            FlexSmall: 12,
            FlexXSmall: 12,
            Cols: 12,
            },
            {
                StaticVariables: [],
            Category: 'Feeds',
            Open: true,
            Transparent: true,
            Alignment: 'center',
            Justify: 'justify-start',
            RowTransparency: 'transparent',
            SocialComponent: true,
            SocialCompPluginid: 'Site_Blogs',
            SocialCompPublicBoolean: 'Site_Blogs_Public',
            GroupParamsProp: 'BlogsPrivacy',
            Name: 'Site Blogs',
            Type: 'Site Blogs',
            DisplayName: 'Site Blogs',
            HasAlignment: true,
            SliderView: true,
            Excerpt: 250,
            Slice: 6,
            TypeCategories: [],
            Elements: [],
            RowColor: '#00ffff',
            ShowComponents: true,
            Icon: 'mdi-blogger',
            Title: 'About',
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,
            MarginTop: 0,
            MarginBottom: 0,
            MarginLeft: 0,
            MarginRight: 0,
            BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },
            FontColor :{
                    hex: '#000000'
            },
            HeaderColor: {
                hex: '#000000'
            },
            FlexXLRG:9,
            FlexLarge: 9,
            FlexMedium: 11,
            FlexSmall: 11,
            FlexXSmall: 10,
            Cols: 12,
            },
            {
                StaticVariables: [],
            Category: 'Feeds',
            Open: true,
            Transparent: true,
            Alignment: 'center',
            Justify: 'justify-center',
            RowTransparency: 'transparent',
            SocialComponent: true,
            SocialCompPluginid: 'Site_Events',
            SocialCompPublicBoolean: 'Site_Events_Public',            
            GroupParamsProp: 'EventsPrivacy',
            PublicPages: false,
            Name: 'Site Events',
            Type: 'Site Events',
            DisplayName: 'Site Events',
            HasAlignment: false,
            FeedView: true,
            Elements: [],
            RowColor: '#00ffff',
            ShowComponents: true,
            Icon: 'mdi-calendar-star',
            Title: 'About',
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,
            MarginTop: 0,
            MarginBottom: 0,
            MarginLeft: 0,
            MarginRight: 0,
            BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },
            FontColor :{
                    hex: '#000000'
            },
            HeaderColor: {
                hex: '#000000'
            },
            FlexXLRG:9,
            FlexLarge: 9,
            FlexMedium: 11,
            FlexSmall: 11,
            FlexXSmall: 10,
            Cols: 12,
            },
            {
                StaticVariables: [],
            Category: 'Feeds',
            Open: true,
            Transparent: true,
            Alignment: 'center',
            Justify: 'justify-start',
            RowTransparency: 'transparent',
            SocialComponent: true,
            SocialCompPluginid: 'Site_Meetups',
            SocialCompPublicBoolean: 'Site_Meetups_Public',            
            GroupParamsProp: 'MeetupsPrivacy',
            PublicPages: false,
            Name: 'Site Meetups',
            Type: 'Site Meetups',
            DisplayName: 'Site Meetups',
            HasAlignment: true,
            SliderView: true,
            Excerpt: 250,
            Slice: 6,
            TypeCategories: [],
            Elements: [],
            RowColor: '#00ffff',
            ShowComponents: true,
            Icon: 'mdi-human-greeting-proximity',
            Title: 'About',
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,
            MarginTop: 0,
            MarginBottom: 0,
            MarginLeft: 0,
            MarginRight: 0,
            BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },
            FontColor :{
                    hex: '#000000'
            },
            HeaderColor: {
                hex: '#000000'
            },
            FlexXLRG:9,
            FlexLarge: 9,
            FlexMedium: 11,
            FlexSmall: 11,
            FlexXSmall: 10,
            Cols: 12,
            },
            {
                StaticVariables: [],
            Category: 'Feeds',
            Open: true,
            Transparent: true,
            Alignment: 'center',
            Justify: 'justify-center',
            RowTransparency: 'transparent',
            //SocialComponent: true,
            PublicPages: false,
            // SocialCompBoolean: 'Site_Has_Blogs',
            Name: 'Notice Board',
            Type: 'Notice Board',
            DisplayName: 'Notice Board',
            HasAlignment: true,
            FeedView: true,
            Elements: [],
            RowColor: '#00ffff',
            ShowComponents: true,
            Icon: 'mdi-bulletin-board',
            Title: 'About',
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,
            MarginTop: 0,
            MarginBottom: 0,
            MarginLeft: 0,
            MarginRight: 0,
            BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },
            FontColor :{
                    hex: '#000000'
            },
            HeaderColor: {
                hex: '#000000'
            },
            FlexXLRG:9,
            FlexLarge: 9,
            FlexMedium: 11,
            FlexSmall: 11,
            FlexXSmall: 10,
            Cols: 12,
            },
            
            {
                StaticVariables: [],
            Category: 'Feeds',
            Open: true,
            Transparent: true,
            Alignment: 'center',
            Justify: 'justify-center',
            RowTransparency: 'transparent',
            SocialComponent: true,
            PublicPages: true,
            // SocialCompBoolean: 'Site_Has_Blogs',
            Name: 'Business Members',
            Type: 'Business Members',
            DisplayName: 'Business Members',
            HasAlignment: false,
            FeedView: true,
            Elements: [],
            RowColor: '#00ffff',
            ShowComponents: true,
            Icon: 'mdi-smart-card',
            Title: 'About',
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,
            MarginTop: 0,
            MarginBottom: 0,
            MarginLeft: 0,
            MarginRight: 0,
            BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },
            FontColor :{
                    hex: '#000000'
            },
            HeaderColor: {
                hex: '#000000'
            },
            FlexXLRG:12,
            FlexLarge: 12,
            FlexMedium: 12,
            FlexSmall: 12,
            FlexXSmall: 12,
            Cols: 12,
            },
            {
                StaticVariables: ['Entityid'],
            Category: 'Misc',
            Open: true,
            Transparent: true,
            Alignment: 'center',
            Justify: 'justify-center',
            RowTransparency: 'transparent',
            Name: 'Table Embed',
            Type: 'Table Embed',
            DisplayName: 'Table Embed',
            HasAlignment: true,
            Elements: [],
            RowColor: '#00ffff',
            ShowComponents: true,
            Icon: 'mdi-table-lock',
            Title: 'About',
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,
            MarginTop: 0,
            MarginBottom: 0,
            MarginLeft: 0,
            MarginRight: 0,
            BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },
            FontColor :{
                    hex: '#000000'
            },
            HeaderColor: {
                hex: '#000000'
            },
            FlexXLRG:10,
            FlexLarge: 10,
            FlexMedium: 11,
            FlexSmall: 11,
            FlexXSmall: 10,
            Cols: 12,
            },									
            {	
                StaticVariables: ['Title','Description','Elements'],	
            Category: 'Misc',							
            Open: true,									
            SectionType: false,									
            Transparent: true,									
            Alignment: 'center',									
            Justify: 'justify-center',									
            RowTransparency: 'transparent',									
            Name: 'Testimonials',									
            Elements: [],									
            RowColor: '#00ffff',									
            ShowComponents: true,									
            Icon: 'mdi-comment-account-outline',									
            Title: 'About',									
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
            MarginTop: 0,									
            MarginBottom: 0,									
            MarginLeft: 0,									
            MarginRight: 0,									
            BGColor: {									
                    hex: '#ffffff',
                    hexa: '#ffffffff',									
            },									
            FontColor :{									
                    hex: '#000000'									
            },									
            HeaderColor: {									
                hex: '#000000'									
            },									
            FlexXLRG:9,									
            FlexLarge: 9,									
            FlexMedium: 11,									
            FlexSmall: 11,									
            FlexXSmall: 10,									
            Cols: 12,									
            },									
            									
            {		
                StaticVariables: [],	
            Category: 'Feeds',								
            Open: true,									
            SectionType: true,									
            Transparent: true,									
            Alignment: 'center',									
            Justify: 'justify-center',									
            RowTransparency: 'transparent',									
            Name: 'Store Products',									
            Elements: [],									
            RowColor: '#00ffff',									
            ShowComponents: true,									
            Icon: 'mdi-cart',									
            Title: 'About',									
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
            MarginTop: 0,									
            MarginBottom: 0,									
            MarginLeft: 0,									
            MarginRight: 0,									
            BGColor: {									
                    hex: '#ffffff',
                    hexa: '#ffffffff',									
            },									
            FontColor :{									
                    hex: '#000000'									
            },									
            HeaderColor: {									
                hex: '#000000'									
            },									
            FlexXLRG:9,									
            FlexLarge: 9,									
            FlexMedium: 11,									
            FlexSmall: 11,									
            FlexXSmall: 10,									
            Cols: 12,									
            },									
            {		
                StaticVariables: ['IsCurrency','SubTitle','Title','CounterInteger','Data'],	
            Category: 'Misc',								
            Open: true,									
            SectionType: true,									
            Transparent: true,									
            Alignment: 'center',									
            Justify: 'justify-center',									
            RowTransparency: 'transparent',									
            Name: 'Counter',									
            Elements: [                
                
            ],									
            RowColor: '#00ffff',									
            ShowComponents: true,									
            Icon: 'mdi-counter',									
            Title: 'Counter',									
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
            MarginTop: 0,									
            MarginBottom: 0,									
            MarginLeft: 0,									
            MarginRight: 0,									
            BGColor: {									
                    hex: '#ffffff',
                    hexa: '#ffffffff',									
            },									
            FontColor :{									
                    hex: '#000000'									
            },									
            HeaderColor: {									
                hex: '#000000'									
            },									
            FlexXLRG:9,									
            FlexLarge: 9,									
            FlexMedium: 11,									
            FlexSmall: 11,									
            FlexXSmall: 10,									
            Cols: 12,	
            CounterIcon: 'mdi-eye'								
            },									
            {	
            StaticVariables: ['Elements','IMG','Title','HeaderImage','Description'],			
            Category: 'Lists',							
            Open: true,									
            SectionType: true,									
            Transparent: true,									
            Alignment: 'center',									
            Justify: 'justify-center',									
            RowTransparency: 'transparent',									
            Name: 'Card Row',
            HasImage: false,									
            Elements: [{	
                    IMG: 'https://firebasestorage.googleapis.com/v0/b/templatizer-9620d.appspot.com/o/LandingPagesShare%2Fweb-developer-vector-illustration-5de192c700231.png?alt=media&token=1dc9a48c-aaf4-473b-87c0-9f7ef84b827f',
                    HasImage: true,								
                Center: 'justify-center',									
                CenteredHeader: true,									
                Name: 'Card Row Single',									
                HeaderFontFamily: 'Roboto',									
                HeaderFontSize: 18,	
                Elevation: 2,								
                HeaderColor: { "alpha": 1, "hex": "#162E4D", "hexa": "#162E4DFF", "hsla": { "h": 213.8181818181818, "s": 0.5555555555555557, "l": 0.1941176470588235, "a": 1 }, "hsva": { "h": 213.8181818181818, "s": 0.7142857142857143, "v": 0.30196078431372547, "a": 1 }, "hue": 213.8181818181818, "rgba": { "r": 22, "g": 46, "b": 77, "a": 1 } },									
                FontSize: 10,									
                FontColor: { "alpha": 1, "hex": "#162E4D", "hexa": "#162E4DFF", "hsla": { "h": 213.8181818181818, "s": 0.5555555555555557, "l": 0.1941176470588235, "a": 1 }, "hsva": { "h": 213.8181818181818, "s": 0.7142857142857143, "v": 0.30196078431372547, "a": 1 }, "hue": 213.8181818181818, "rgba": { "r": 22, "g": 46, "b": 77, "a": 1 } },									
                									
                Title: 'Type',									
                Description: `<div style="text-align: center;">Lorem ipsum dolor sit amet.</div>`,									
                FlexXLRG:12,									
                FlexLarge: 12,									
                FlexMedium: 6,									
                FlexSmall: 6,									
                FlexXSmall: 8,									
                Cols: 3,									
                Justify: 'justify-center',									
                RowColor: '#00ffff',									
                ShowComponents: true,									
                Icon: 'mdi-cards',									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                IsDark: true,									
                									
                									
            }],									
            RowColor: '#00ffff',									
            ShowComponents: true,									
            Icon: 'mdi-cards-variant',									
            Title: 'Who will benefit',									
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
            MarginTop: 0,									
            MarginBottom: 0,									
            MarginLeft: 0,									
            MarginRight: 0,									
            BGColor: {									
                    hex: '#ffffff',
                    hexa: '#ffffffff',									
            },									
            FontColor :{									
                    hex: '#000000'									
            },									
            HeaderColor: {									
                hex: '#000000'									
            },									
            FlexXLRG:10,									
            FlexLarge: 10,									
            FlexMedium: 11,									
            FlexSmall: 11,									
            FlexXSmall: 10,									
            Cols: 12,									
            },									
            {		
            StaticVariables: ['Elements','IMG','Title','Description','HeaderImage'],		
            Category: 'Lists',								
            Open: true,									
            SectionType: true,									
            Transparent: true,									
            Alignment: 'center',									
            Justify: 'justify-center',									
            RowTransparency: 'transparent',									
            Name: 'Card Blocks',									
            Elements: [],									
            RowColor: '#00ffff',									
            ShowComponents: true,									
            Icon: 'mdi-card-plus-outline',									
            Title: 'About',									
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
            MarginTop: 0,									
            MarginBottom: 0,									
            MarginLeft: 0,									
            MarginRight: 0,									
            BGColor: {									
                    hex: '#ffffff',
                    hexa: '#ffffffff',									
            },									
            FontColor :{									
                    hex: '#000000'									
            },									
            HeaderColor: {									
                hex: '#000000'									
            },									
            FlexXLRG:9,									
            FlexLarge: 9,									
            FlexMedium: 11,									
            FlexSmall: 11,									
            FlexXSmall: 10,									
            Cols: 12,									
            },									
            {				
            Category: 'Graphics',							
                SectionType: true,									
                Transparent: true,									
                Alignment: 'center',									
                Justify: 'justify-center',									
                RowTransparency: 'transparent',									
                Open: true,									
                Height: 300,									
            	StaticVariables: ['BGColor'],								
                Name: 'Clipped Tab',									
                BGColor: {									
                    hex:'#009BFFFF'									
                },									
                ShowComponents: true,									
                ClippedbyPath: true,									
                ClippedPathOption: 'polygon',									
                TopLeftCrnrXValue: 25,									
                TopLeftCrnrYValue: 0,									
                TopLeftCrnrX: '25%',									
                TopLeftCrnrY: '0%',									
                TopRightCrnrXValue: 100,									
                TopRightCrnrYValue: 0,									
                TopRightCrnrX: '100%',									
                TopRightCrnrY: '0%',									
                BottomRightCrnrXValue: 75,									
                BottomRightCrnrYValue: 100,									
                BottomRightCrnrX: '75%',									
                BottomRightCrnrY: '100%',									
                BottomLeftCrnrXValue: 0,									
                BottomLeftCrnrYValue: 100,									
                BottomLeftCrnrX: '0%',									
                BottomLeftCrnrY: '100%',									
                Clipped: true,									
                Icon: 'mdi-drawing',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:12,									
                FlexLarge: 12,									
                FlexMedium: 12,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
                Height: 400,									
                Elements: []									
            },									
           									
            {				
            Category: 'Parallax',							
                RowColor: '#ffffff',									
                Name: 'Parallax',	
                StaticVariables: ['IMG','Height'],								
                SectionType: true,									
                Transparent: true,									
            Alignment: 'center',									
            Justify: 'justify-center',									
            RowTransparency: 'transparent',									
                Open: true,									
                ShowComponents: true,									
                Icon: 'mdi-image-area',									
                Height: 300,									
                Elements: [],									
                Rows: [],									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                FlexXLRG:12,									
                FlexLarge: 12,									
                FlexMedium: 12,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },									
            									
            {					
            Category: 'Images',		
            StaticVariables: ['IMG','Title','Description'],						
                RowColor: '#ffffff',									
                Name: 'Image',									
                ShowComponents: true,									
                Height: 200,									
                Icon: 'mdi-image',									
                Width: '60%',
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                FlexXLRG:12,									
                FlexLarge: 12,									
                FlexMedium: 12,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },									
            {	
                StaticVariables: ['Items'],				
            Category: 'Misc',								
                RowColor: '#00ffff',									
                Name: 'Timeline',									
                Items: [									
                    {									
                    HasIcon: true,									
                    Name: 'Timeline Item',									
                    Title: 'Lorem Ipsum Dolor',									
                    Description: 'Lorem ipsum dolor sit amet, no nam oblique veritus.',									
                    HasActionButton: true,									
                    ActionButtonName: 'Button',									
                    TitleColor: 'white',									
                    color: 'red lighten-2',									
                    icon: 'mdi-star',									
                    },									
                    {									
                    HasIcon: true,									
                    Name: 'Timeline Item',									
                    Title: 'Lorem Ipsum Dolor',									
                    Description: 'Lorem ipsum dolor sit amet, no nam oblique veritus.',									
                    HasActionButton: true,									
                    ActionButtonName: 'Button',									
                    TitleColor: 'white',									
                    color: 'purple darken-1',									
                    icon: 'mdi-book-variant',									
                    },									
                ],									
                ShowComponents: true,									
                Icon: 'mdi-timeline-text-outline',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },
            {			
                StaticVariables: ['SelectedFAQ'],			
            Category: 'Feeds',							
                RowColor: '#00ffff',									
                Name: 'FAQ',									
                ShowComponents: true,									
                Icon: 'mdi-help',									
                Title: 'About',	
                SelectedFAQ: [],								
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },	
            {	
                StaticVariables: ['Title','Description','ListItems'],					
            Category: 'Lists',							
                RowColor: '#00ffff',									
                Name: 'Description List',									
                ShowComponents: true,									
                Icon: 'mdi-format-list-text',									
                Title: 'About',	
                ListItems: [],								
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },	
            {		
                StaticVariables: ['Documents'],					
            Category: 'Feeds',						
                RowColor: '#00ffff',									
                Name: 'Documents Table',									
                ShowComponents: true,									
                Icon: 'mdi-file-cabinet',									
                Title: 'About',				
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,
                Documents: [],									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },	
            {	
                StaticVariables: ['Assets','IMG','Title','Description','HeaderImage'],			
            Category: 'Gallery',
                RowTransparency: 'transparent',									
                RowColor: '#00ffff',
                Assets: [],									
                Name: 'Carousel',									
                ShowComponents: true,									
                Icon: 'mdi-view-carousel',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },								
            {			
            Category: 'Titles',
                RowTransparency: 'transparent',									
                RowColor: '#00ffff',									
                Name: 'Title',						
                StaticVariables: ['Title','Description','IMG'],			
                ShowComponents: true,									
                Icon: 'mdi-format-title',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },
            {	
                StaticVariables: ['Headers','IMG','Data','Description','Icon'],				
            Category: 'Misc',							
                RowColor: '#00ffff',									
                Name: 'HTML Table',	
                IMG: '',
                Headers: [
                ],	
                Data: [

                ]	,						
                ShowComponents: true,									
                Icon: 'mdi-folder-table',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },	
            {				
                StaticVariables: ['Title','Description','Icon','FontColor','HeaderColor','Color'],	
            Category: 'Misc',									
                RowColor: '#00ffff',									
                Name: 'Info Sheet',									
                ShowComponents: true,									
                Icon: 'mdi-alert',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                Color: 'red',	
                Elevation: 6,
                AlertIcon: 'mdi-alert',	
                BorderPosition: 'top',
                ColoredBorder: true,							
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },								
            {					
            Category: 'Text',									
                RowColor: '#00ffff',									
                Name: 'HTML Box',		
                StaticVariables: ['Title','Description','IMG'],							
                ShowComponents: true,									
                Icon: 'mdi-card-text',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },	
            {		
                StaticVariables: ['Entityid'],		
            Category: 'Feeds',								
                RowColor: '#00ffff',									
                Name: 'Wiki Collection',									
                ShowComponents: true,									
                Icon: 'mdi-wikipedia',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },								
            {				
                StaticVariables: ['Entityid'],		
            Category: 'Call to Action',								
                RowColor: '#00ffff',									
                Name: 'Web Form',									
                ButtonAlignment: 'justify-end',									
                ShowComponents: true,									
                Icon: 'mdi-email-outline',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },		
            {			
                StaticVariables: ['Entityid'],		
            Category: 'Call to Action',								
                RowColor: '#00ffff',									
                Name: 'Survey Form',									
                ButtonAlignment: 'justify-end',									
                ShowComponents: false,									
                Icon: 'mdi-email-outline',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },							
           									
            {		
                StaticVariables: ['FrameURL'],			
            Category: 'Feeds',								
                RowColor: '#ffffff00',	
                FrameURL: 'https://www.google.com/maps/d/u/0/embed?mid=1Ub6jWcGRfl0Lfltt1QefuAeVV6uSBjk&ehbc=2E312F',								
                Transparent: true,									
            Justify: 'justify-center',									
                Name: 'Google My Maps',									
                ShowComponents: true,									
                Elements: [],									
                Icon: 'mdi-google-my-business',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },	
            			
            {
                StaticVariables: ['RSSURL'],
            Category: 'Feeds',
            Open: true,
            Transparent: true,
            Alignment: 'center',
            Justify: 'justify-center',
            RowTransparency: 'transparent',
            Name: 'RSS Feed',
            Type: 'RSS Feed',
            DisplayName: 'RSS Feed',
            HasAlignment: true,
            Elements: [],
            RowColor: '#00ffff',
            ShowComponents: true,
            Icon: 'mdi-rss',
            Title: 'About',
            Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,
            MarginTop: 0,
            MarginBottom: 0,
            MarginLeft: 0,
            MarginRight: 0,
            RSSURL: 'https://feeds.24.com/articles/news24/TopStories/rss',
            BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },
            FontColor :{
                    hex: '#000000'
            },
            HeaderColor: {
                hex: '#000000'
            },
            FlexXLRG:9,
            FlexLarge: 9,
            FlexMedium: 11,
            FlexSmall: 11,
            FlexXSmall: 10,
            Cols: 12,
            },									
            {			
                StaticVariables: ['FrameURL'],		
            Category: 'Misc',							
                RowColor: '#00ffff',									
                RowTransparency: 'transparent',									
                Name: 'IFRAME',									
                ContentAlign: 'center',									
                ShowComponents: true,									
                Elements: [],									
                Icon: 'mdi-iframe',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 6,									
                FlexMedium: 6,									
                FlexSmall: 6,									
                FlexXSmall: 12,									
                Cols: 12,									
            },									
            									
            {		
                StaticVariables: ['Assets','IMG','Title','Description','HeaderImage'],			
            Category: 'Gallery',							
                SectionType: true,									
                Transparent: true,									
            Alignment: 'center',									
            Justify: 'justify-center',									
            RowTransparency: 'transparent',									
                Open: true,									
                RowColor: '#00ffff',									
                Name: 'Gallery',									
                Assets: [],								
                HideCaptions: false,									
                ShowComponents: true,									
                Elements: [],									
                Icon: 'mdi-folder-image',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus.`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:12,									
                FlexLarge: 12,									
                FlexMedium: 12,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },									
			{									
                RowColor: '#ffffff',									
                Name: '',
                DisplayName: '',
                DataViewName: 'Data Single Standard',	
                Icon: '',								
                SectionType: true,									
                Transparent: true,									
            Alignment: 'center',									
            Justify: 'justify-center',									
            RowTransparency: 'transparent',									
                Open: true,									
                ShowComponents: true,									
                Icon: 'mdi-database',									
                Height: 300,									
                Elements: [],									
                Rows: [],									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                FlexXLRG:10,									
                FlexLarge: 10,									
                FlexMedium: 10,									
                FlexSmall: 11,									
                FlexXSmall: 11,									
                Cols: 12,									
            },
            
            {									
                RowColor: '#ffffff',									
                Name: '',
                DisplayName: '',
                DataViewName: 'Data Single Feature List',	
                DataSingleStandard: true,	
                Fields: [],			
                Transparent: true,									
                Alignment: 'center',									
                Justify: 'justify-center',									
                RowTransparency: 'transparent',									
                Open: true,									
                ShowComponents: true,									
                Icon: 'mdi-format-list-checks',									
                Height: 300,									
                Rows: [],									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                FlexXLRG:11,									
                FlexLarge: 11,									
                FlexMedium: 11,									
                FlexSmall: 11,									
                FlexXSmall: 11,										
                Cols: 12,									
            },
            {									
                RowColor: '#ffffff',									
                Name: '',
                DisplayName: '',
                DataViewName: 'Data Single Fields',	
                DataSingleStandard: true,	
                Fields: [],			
                Transparent: true,									
                Alignment: 'center',									
                Justify: 'justify-center',									
                RowTransparency: 'transparent',									
                Open: true,									
                ShowComponents: true,									
                Icon: 'mdi-clipboard-list',									
                Height: 300,									
                Rows: [],									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                FlexXLRG:11,									
                FlexLarge: 11,									
                FlexMedium: 11,									
                FlexSmall: 11,									
                FlexXSmall: 11,										
                Cols: 12,									
            },
            {									
                RowColor: '#ffffff',									
                Name: '',
                DisplayName: '',
                Icon: '',
                DataViewName: 'Data Single Activities',	
                DataSingleStandard: true,				
                Transparent: true,									
                Alignment: 'center',									
                Justify: 'justify-center',									
                RowTransparency: 'transparent',									
                Open: true,									
                ShowComponents: true,									
                Icon: 'mdi-clipboard-list',									
                Height: 300,									
                Rows: [],									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                FlexXLRG:11,									
                FlexLarge: 11,									
                FlexMedium: 11,									
                FlexSmall: 11,									
                FlexXSmall: 11,										
                Cols: 12,									
            },
            {									
                RowColor: '#ffffff',									
                Name: '',
                DisplayName: '',
                DataViewName: 'Data Single Cabinet',	
                Icon: '',								
                SectionType: true,									
                Transparent: true,									
            Alignment: 'center',									
            Justify: 'justify-center',									
            RowTransparency: 'transparent',									
                Open: true,									
                ShowComponents: true,									
                Icon: 'mdi-file-cabinet',									
                Height: 300,									
                Elements: [],									
                Rows: [],									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                FlexXLRG:11,									
                FlexLarge: 11,									
                FlexMedium: 11,									
                FlexSmall: 11,									
                FlexXSmall: 11,									
                Cols: 12,									
            },
            {									
                RowColor: '#ffffff',									
                Name: '',
                DisplayName: '',
                DataViewName: 'Data Single Document Register',	
                DataSingleCabinet: true,				
                Transparent: true,									
                Alignment: 'center',									
                Justify: 'justify-center',									
                RowTransparency: 'transparent',									
                Open: true,									
                ShowComponents: true,									
                Icon: 'mdi-file-document-multiple',									
                Height: 300,									
                Rows: [],									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                FlexXLRG:11,									
                FlexLarge: 11,									
                FlexMedium: 11,									
                FlexSmall: 11,									
                FlexXSmall: 11,										
                Cols: 12,									
            },
            {									
                RowColor: '#ffffff',									
                Name: '',
                DisplayName: '',
                Icon: '',
                DataViewName: 'Data Single Gallery',	
                DataSingleCabinet: true,				
                Transparent: true,									
                Alignment: 'center',									
                Justify: 'justify-center',									
                RowTransparency: 'transparent',									
                Open: true,									
                ShowComponents: true,									
                Icon: 'mdi-folder-image',									
                Height: 300,								
                Rows: [],									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                FlexXLRG:11,									
                FlexLarge: 11,									
                FlexMedium: 11,									
                FlexSmall: 11,									
                FlexXSmall: 11,										
                Cols: 12,									
            },
            {									
                RowColor: '#ffffff',									
                Name: '',
                DisplayName: '',
                DataViewName: 'Data Single Related',	
                Icon: '',								
                SectionType: true,									
                Transparent: true,									
            Alignment: 'center',									
            Justify: 'justify-center',									
            RowTransparency: 'transparent',									
                Open: true,									
                ShowComponents: true,									
                Icon: 'mdi-database-arrow-down-outline',									
                Height: 300,									
                Elements: [],									
                Rows: [],									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                FlexXLRG:11,									
                FlexLarge: 11,									
                FlexMedium: 11,									
                FlexSmall: 11,									
                FlexXSmall: 11,									
                Cols: 12,									
            },
            
            {									
                RowColor: '#ffffff',									
                Name: '',
                DisplayName: '',
                DataViewName: 'Data Single Related Data',	
                DataSingleRelated: true,				
                Transparent: true,									
                Alignment: 'center',									
                Justify: 'justify-center',									
                RowTransparency: 'transparent',									
                Open: true,									
                ShowComponents: true,									
                Icon: 'mdi-database-arrow-down-outline',									
                Height: 300,								
                Rows: [],									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                FlexXLRG:11,									
                FlexLarge: 11,									
                FlexMedium: 11,									
                FlexSmall: 11,									
                FlexXSmall: 11,										
                Cols: 12,									
            },
            {									
                RowColor: '#ffffff',									
                Name: '',
                DisplayName: '',
                DataViewName: 'Data Single SubCollection',	
                DataSingleRelated: true,				
                Transparent: true,									
                Alignment: 'center',									
                Justify: 'justify-center',									
                RowTransparency: 'transparent',									
                Open: true,									
                ShowComponents: true,									
                Icon: 'mdi-database-arrow-down-outline',									
                Height: 300,								
                Rows: [],									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                FlexXLRG:11,									
                FlexLarge: 11,									
                FlexMedium: 11,									
                FlexSmall: 11,									
                FlexXSmall: 11,										
                Cols: 12,									
            },
            {									
                RowColor: '#ffffff',									
                Name: '',
                DisplayName: '',
                Icon: '',
                DataViewName: 'Data Single Related',	
                DataSingleCabinet: true,				
                Transparent: true,									
                Alignment: 'center',									
                Justify: 'justify-center',									
                RowTransparency: 'transparent',									
                Open: true,									
                ShowComponents: true,									
                Icon: 'mdi-database',									
                Height: 300,								
                Rows: [],									
                BGColor: {
                    hex: '#ffffff',
                    hexa: '#ffffffff'
            },									
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,									
                FlexXLRG:11,									
                FlexLarge: 11,									
                FlexMedium: 11,									
                FlexSmall: 11,									
                FlexXSmall: 11,										
                Cols: 12,									
            },		
            									
            									
        ],
        FAQFilterItem: -1,
        FAQSearch: '',
        }
    },
    computed:{
        FontOptions(){
            return this.$store.state.FontOptions
        },
        TypeSelection(){
            return this.EditedTab.Name === 'blank' && !this.EditedTab.SectionType
        },
        NavStyle(){
            return this.MiniView ? 'position: fixed;z-index: 99;height: 500px;right:0px;top:'+this.WindowHeight/5+'px;' : 'position: fixed;z-index: 99;height: 560px;right:100px;top:200px;'
        },
         MiniView(){
            return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
        },
        SelectedEntity(){
            if(this.NewTableOption){
                let entity = Object.assign({},this.NewTableOption)
                entity.AllFields = entity.Headers
                return entity
            }
            else{
                return this.CurrentEntity
            }
        },
        StyleItems(){
            return [
                // /GalAssetsComponent
                {
                Name: 'Child Elements',
                compname: 'SectionTypeAddChildComponent',
                Children: ['Data Single Related','blank','Data Single Cabinet','Data Single Standard'],
                Conditions: [],
                Icon: 'mdi-application-settings'
                },
                {
                Name: 'Basic Config',
                compname: 'BasicContentConfigComponent',
                Children: ['RSS Feed','Store Product Single','Card Link','Counter Single','Survey Form','Web Form','FAQ','IFRAME','Info Sheet','Google My Maps','Table Embed','Counter Single','Info Card','Timeline Item'],
                Conditions: [],
                Icon: 'mdi-code-tags'
                },
                {
                Name: 'Basic Data View Types',
                compname: 'BasicDataViewTypesConfigComponent',
                Children: ['Data Single Document Register','Data Single Gallery','Wiki Collection',
                'Data Single Fields','Data Single Activities','Data Single Related Data','Data Single SubCollection'],
                Conditions: [],
                Icon: 'mdi-database',
                GlobalQualifier: 'WikiType'
                },
                {
                Name: 'Basic Data View Title',
                compname: 'BasicDataViewTitleConfigComponent',
                Children: ['Data Single Document Register','Data Single Gallery','Wiki Collection','Data Single Standard',
                'Data Single Fields','Data Single Activities','Data Single Related Data','Data Single SubCollection'],
                Conditions: [],
                Icon: 'mdi-format-title'
                },
                {
                Name: 'Items Config',
                compname: 'ItemsComponent',
                Children: ['HTML Table','Timeline'],
                Conditions: [],
                Icon: 'mdi-view-list'
                },
                 {
                Name: 'Testimonials',
                compname: 'TestimonialsComponent',
                Children: ['Testimonials'],
                Conditions: [],
                Icon: 'mdi-account-voice'
                },
                {
                Name: 'Title',
                ContentElementID: 'Title',
                compname: 'TitleConfiguringComponent',
                Children: ['HTML Box','Image','Title','Gallery','FAQ','Wiki Collection','HTML Table','Description List','Info Card','Web Form',
                'Card Block Single','Card Row Single','Counter Single','Store Product Single','Parallax','Card Row','Clipped Tab',
                'Testimonials','Site Articles','Site Blogs','Site Meetups','Notice Board','Site Events','Social Site Posts','Social Posts','Card Link',
                'Business Members','Table Embed','RSS Feed','Store Products','Counter','Card Blocks','Documents Table','Carousel','Info Sheet',
                'Survey Form','Google My Maps','IFRAME'],
                Conditions: [
                    {
                    Child: 'Image',
                    Condition: 'HasTextBox',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Clipped Tab',
                    Condition: 'Animated',
                    ConditionType: 'Prop'
                    }
                ],
                DisqualifyingProp: 'ContentFromField',
                Icon: 'mdi-format-title'
                },
                {
                Name: 'Write Up',
                compname: 'WriteupComponent',              
                ContentElementID: 'Description',
                Children: ['HTML Box','Gallery','Info Sheet','Card Block Single','Card Row Single','Card Row','Store Product Single','Image','Parallax'],
                Conditions: [],
                DisqualifyingProp: 'ContentFromField',
                Icon: 'mdi-pencil',
                Conditions: [
                    {
                    Child: 'Image',
                    Condition: 'HasTextBox',
                    ConditionType: 'Prop'
                    },
                     {
                    Child: 'Parallax',
                    Condition: 'HasTextBox',
                    ConditionType: 'Prop'
                    }
                ],
                },
                 
                {
                Name: 'Image',
                compname: 'ImageConfiguringComponent',              
                ContentElementID: 'IMG',
                Children: ['HTML Box','Title','HTML Table','Gallery','Card Block Single','Card Row Single','Card Row','Store Product Single','Image','Parallax','Clipped Tab'],
                Conditions: [
                    {
                    Child: 'Title',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'HTML Table',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'HTML Box',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Gallery',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Card Block Single',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Card Row Single',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Card Row',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    },
                     {
                    Child: 'Clipped Tab',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Store Product Single',
                    Condition: 'HasImage',
                    ConditionType: 'Prop'
                    }
                ],
                Icon: 'mdi-file-image'
                },
                
               
                
                {
                Name: 'Clipping Config',
                compname: 'ClippingConfigurationComponent',
                Children: ['Parallax','Image','Clipped Tab'],
                Conditions: [],
                Icon: 'mdi-drawing'
                },
                
                {
                Name: 'Data Calls',
                compname: 'DataTableCallsComponent',
                Children: ['Store Products','Counter Single'],
                Conditions: [],
                Icon: 'mdi-database'
                },
                {
                Name: 'List Config',
                compname: 'DescriptionListConfigComponent',
                Children: ['Description List'],
                Conditions: [],
                Icon: 'mdi-format-list-text'
                },
             
                {
                Name: 'Social Feed Config',
                compname: 'SocialConfigFeedComponent',
                Children: ['Site Articles','Site Blogs','Site Meetups','Site Events','Site Groups'],
                Conditions: [],
                Icon: 'mdi-google-circles-communities'
                },
                 {
                Name: 'Box Styling',
                compname: 'BoxStylingComponent',
                Children: ['HTML Box','Image','Parallax','Title','Gallery','FAQ','Wiki Collection','HTML Table','Description List','Info Card','Web Form',
                'Clipped Tab','Card Block Single','Card Row Single','Timeline Item','Counter Single','Store Product Single'],
                Conditions: [
                    {
                    Child: 'Image',
                    Condition: 'HasTextBox',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Parallax',
                    Condition: 'HasTextBox',
                    ConditionType: 'Prop'
                    }
                ],
                Icon: 'mdi-border-style'
                },
                {
                Name: 'Action Button',
                compname: 'ActionButtonConfiguringComponent',
                Children: ['HTML Box','Image','Parallax','Card Row Single','Clipped Tab'],
                Conditions: [
                    {
                    Child: 'HTML Box',
                    Condition: 'HasActionButton',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Image',
                    Condition: 'HasActionButton',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Parallax',
                    Condition: 'HasActionButton',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Card Row Single',
                    Condition: 'HasActionButton',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Clipped Tab',
                    Condition: 'HasActionButton',
                    ConditionType: 'Prop'
                    },
                ],
                Icon: 'mdi-gesture-tap-button'
                },
                {
                Name: 'Box Wrapping',
                compname: 'BoxWrappingComponent',
                Children: ['Image'],
                Conditions: [
                    {
                    Child: 'Image',
                    Condition: 'HasTextBox',
                    ConditionType: 'Prop'
                    },
                ],
                Icon: 'mdi-format-align-center'
                },
                {
                Name: 'Advanced',
                compname: 'AdvancedOptionsComponent',
                Children: ['HTML Box','Image','Title','Gallery','FAQ','Wiki Collection','HTML Table','Description List','Info Card','Web Form',
                'Clipped Tab','Card Block Single','Card Row Single','Timeline Item','Counter Single','Store Product Single','Parallax','Card Row',
                'Testimonials','Site Articles','Site Blogs','Site Meetups','Notice Board','Site Events','Social Site Posts','Social Posts','Card Link',
                'Business Members','Table Embed','RSS Feed','Store Products','Counter','Card Blocks','Documents Table','Carousel','Info Sheet',
                'Survey Form','Google My Maps','IFRAME'],
                Conditions: [],
                Icon: 'mdi-cogs'
                },
                {
                Name: 'Waves',
                compname: 'WavesConfigComponent',
                Children: ['HTML Box','Image','Title','Gallery','FAQ','Wiki Collection','HTML Table','Description List','Info Card','Web Form',
                'Clipped Tab','Card Block Single','Card Row Single','Timeline Item','Counter Single','Store Product Single','Parallax','Card Row',
                'Testimonials','Site Articles','Site Blogs','Site Meetups','Notice Board','Site Events','Social Site Posts','Social Posts','Card Link',
                'Business Members','Table Embed','RSS Feed','Store Products','Counter','Card Blocks','Documents Table','Carousel','Info Sheet',
                'Survey Form','Google My Maps','IFRAME','blank'],
                Conditions: [],
                Icon: 'mdi-sine-wave'
                },
                  {
                Name: 'Margin Styling',
                compname: 'MarginStylingComponent',
                Children: ['HTML Box','Image','Title','Gallery','FAQ','Wiki Collection','HTML Table','Description List','Info Card','Web Form',
                'Clipped Tab','Card Block Single','Card Row Single','Timeline Item','Counter Single','Store Product Single','Parallax','Card Row',
                'Testimonials','Site Articles','Site Blogs','Site Meetups','Notice Board','Site Events','Social Site Posts','Social Posts','Card Link',
                'Business Members','Table Embed','RSS Feed','Store Products','Counter','Card Blocks','Timeline','Documents Table','Carousel','Info Sheet',
                'Survey Form','Google My Maps','IFRAME','blank'],
                Conditions: [],
                Icon: 'mdi-table-row-plus-after'
                },
                {
                Name: 'Sizing',
                compname: 'ElementSizingOptionsComponent',
                Children: ['blank','HTML Box','Image','Title','Gallery','FAQ','Wiki Collection','HTML Table','Description List','Info Card','Web Form',
                'Clipped Tab','Card Block Single','Card Row Single','Timeline Item','Counter Single','Store Product Single','Parallax','Card Row',
                'Testimonials','Site Articles','Site Blogs','Site Meetups','Notice Board','Site Events','Social Site Posts','Social Posts','Card Link',
                'Business Members','Table Embed','RSS Feed','Store Products','Counter','Card Blocks','Timeline','Documents Table','Carousel','Info Sheet',
                'Survey Form','Google My Maps','IFRAME','Data Single Cabinet','Data Single Document Register','Data Single Gallery','Site Groups',
                'Data Single Standard','Data Single Fields','Data Single Activities','Data Single Related'],
                Conditions: [],
                Icon: 'mdi-arrow-expand-horizontal'
                },
                
                {
                Name: 'Assets',
                compname: 'GalAssetsComponent',
                Children: ['Gallery','Carousel','Image'],
                ContentElementID: 'Assets',
                Conditions: [
                    {
                    Child: 'Image',
                    Condition: 'IMGRotation',
                    ConditionType: 'Prop'
                    },
                    {
                    Child: 'Image',
                    Condition: 'ComparingImages',
                    ConditionType: 'Prop'
                    },
                ],
                Icon: 'mdi-folder-multiple-image'
                },
               
                ]
        },
        FilteredTabStyleItems(){
            return this.TabStyleItems.filter(item => {
                return item
                //.Name !== 'Child Elements'
            })
        },
        TabStyleItems(){
            if(this.EditedTab && !this.EditedTab.DataViewName){
                return this.StyleItems.filter(item => {return item.Children.includes(this.EditedTab.Name) || item.GlobalQualifier && this[item.GlobalQualifier]}).filter(item => {
                    let conditionalchild = item.Conditions.find(cond => {return cond.Child === this.EditedTab.Name})
               
                    return !conditionalchild && !item.DisqualifyingProp || !conditionalchild && item.DisqualifyingProp && !this.EditedTab[item.DisqualifyingProp]
                    || conditionalchild && conditionalchild.ConditionType === 'Prop' && this.EditedTab[conditionalchild.Condition] && !item.DisqualifyingProp || 
                    conditionalchild && conditionalchild.ConditionType === 'Prop' && this.EditedTab[conditionalchild.Condition] && item.DisqualifyingProp && !this.EditedTab[item.DisqualifyingProp] ||
                    conditionalchild && conditionalchild.ConditionType === 'Method' && this[conditionalchild.Condition](this.EditedTab) && !item.DisqualifyingProp || 
                    conditionalchild && conditionalchild.ConditionType === 'Method' && this[conditionalchild.Condition](this.EditedTab) && item.DisqualifyingProp && !this.EditedTab[item.DisqualifyingProp]
                    || item.GlobalQualifier && this[item.GlobalQualifier]
                }).map((item,index) => {
                    item.Index = index
                    return item
                })
            }
            else if(this.EditedTab && this.EditedTab.DataViewName){
                return this.StyleItems.filter(item => {return item.Children.includes(this.EditedTab.DataViewName)})
            }
            else{
                return []
            }
        },
        UseGroupAssets(){
            return this.$route.name === 'GroupPageBuilder' || this.$route.name === 'GroupPageEditor'
        },
        CurrentEntityPhotoFields(){
            return this.CurrentEntity.AllFields
            .filter(field => {
                return field.Type === 'Single File Upload' && field.FeaturedPhoto
            })
        },
        FrequentlyAskedQuestionsKeys(){
            let keywords = []
            this.FrequentlyAskedQuestions.map(faq => {
                if(faq.KeyWords){
                    faq.KeyWords.map(keyword => {
                        let oncheck = keywords.find(obj => obj === keyword)
                        if(!oncheck){
                            keywords.push(keyword)
                        }
                    })
                }
            })
            return keywords
        },
        FrequentlyAskedQuestionsSearched(){
            return this.FrequentlyAskedQuestionsFiltered.filter(faq => {
                if(this.FAQSearch){
                    return faq.Question.toLowerCase().includes(this.FAQSearch.toLowerCase())
                }
                else{
                    return faq
                }
            })
        },
        FrequentlyAskedQuestionsFiltered(){
            return this.FrequentlyAskedQuestions.filter(faq => {
                if(this.FAQFilterItem > -1){
                    return faq.KeyWords && faq.KeyWords.includes(this.FrequentlyAskedQuestionsKeys[this.FAQFilterItem])
                }
                else{
                    return faq
                }
            })
        },
        BooleanFields(){
            if(this.CurrentEntity && this.CurrentEntity.AllFields){
                return this.CurrentEntity.AllFields.filter(field => {
                    return field.Type === 'Boolean'
                })
            }
        },
        ComputedSystemGuides(){
            return this.SystemGuides.map(guidedoc => {
                let newguidedoc = {
                    Name: guidedoc.Name,
                    Description: guidedoc.Description,
                    Category: guidedoc.Category,
                    CarouselItems: guidedoc.CarouselItems,
                    RoutePath: guidedoc.RoutePath,
                    id: guidedoc.id

                }
                return newguidedoc
            })
        },
        AdvancedComputedLibraryColors(){
      let arr1 = this.LibraryColors
      let arr2 = [
        'primary',
        'accent',
        'secondary',
        'pop',
        'morning',
        'night',
        'fieldcard',
        'links',
        'background',
      ]
      let arr3 = arr1.concat(arr2)
      let arr4 = []
      arr3.map(color => {
        arr4.push(color)
        arr4.push(color+' lighten-1')
        arr4.push(color+' lighten-2')
        arr4.push(color+' lighten-3')
        arr4.push(color+' lighten-4')
        arr4.push(color+' lighten-5')
        arr4.push(color+' darken-1')
        arr4.push(color+' darken-2')
        arr4.push(color+' darken-3')
        arr4.push(color+' darken-4')
        arr4.push(color+' darken-5')
        arr4.push(color+' accent-1')
        arr4.push(color+' accent-2')
        arr4.push(color+' accent-3')
        arr4.push(color+' accent-4')
      })
      return arr4
    },
        EntityFieldsandFeatures(){
            let featurelist = []
            let allfields = []
            if(this.ClsfdNavList && this.ClsfdNavList.FeatureList){
                featurelist = this.ClsfdNavList.FeatureList
            }
            if(this.CurrentEntity && this.CurrentEntity.AllFields){
                allfields = this.CurrentEntity.AllFields
            }
            
            return allfields.concat(featurelist)
        },
        SystemRoutes(){
            let routes = this.$router.getRoutes()
            return routes
        },
        WikiEntityFields(){
            if(this.EditedTab && this.EditedTab.Name === 'Wiki Collection' && this.EditedTab.Entityid){
                let wikientity = this.WikiEntities.find(obj => obj.id === this.EditedTab.Entityid)
                return wikientity.WikiFields
            }
        },
        ComputedWikiEntities(){
            return this.WikiEntities
            .filter(entity => {
                if(this.$route.meta && this.$route.meta.ClassifiedListingBuilder){
                    //we need to get the classifiedentity somehow and pass it's publishtype to the this.Publishttypoe prop
                    //note this is clasifiedeneity, NOT on catnavlist dude
                    return entity
                }
                else{
                    return entity.PublishType === this.PublishType
                }                
            })
        },
        DataCollectionCategoryOptions(){
             if(this.EditedTab && this.EditedTab.DataCountCollection){
                if(this.EditedTab.Countby && this.EditedTab.Countby === 'Option Set'){
                    return this.EditedTab.CountCategory.Options
                }
                 else if(this.EditedTab.Countby && this.EditedTab.Countby === 'Lookup'){
                    return this.EditedTab.CountCategory.Options.map(record => {
                        record.Name = record[this.EditedTab.CountCategory.Identifier]
                        return record
                    })
                }
             }
        },
        DataCollectionCategories(){
           
            if(this.EditedTab && this.EditedTab.DataCountCollection){                
                return this.EditedTab.DataCountCollection.Categories.filter(cat => {
                    console.log(cat.Type,this.EditedTab.Countby)
                   return cat.Type === this.EditedTab.Countby
                })
            }
            
        },
        DataCountCollections(){
            return this.SystemEntities.map(entity => {
                let countobj = {
                    Name: entity.DisplayName,
                    ArrayName: entity.DisplayName.split(' ').join('')+'Array',
                    //should be wiki
                    CollectionName: entity.DisplayName.split(' ').join('').toLowerCase(),
                    CountbyOptions: [
                        'Option Set',
                        'Lookup'
                    ],
                    Categories: [
                        // {
                        //     Name: 'Product_Type',
                        // Type: 'Option Set',
                        // Options: []
                        // },
                        // {             
                        //     Name: 'OEM',
                        //     Type: 'Lookup Field',
                        //     Options: 'EquipmentManufacturersWikiArray',
                        //     Identifier: 'Name'
                        // }
                    ]
                }
                countobj.Categories = entity.AllFields.filter(field => {
                    return field.Type === 'Option Set' || field.Type === 'Lookup'
                }).map(field => {
                    let fieldcat = {
                        Name: field.Name,
                        Type: field.Type,
                        Options: field.Options
                    }
                    if(field.Type === 'Option Set'){
                        fieldcat.Options = field.Options
                    }
                    else if(field.RelatedRecord){
                        //console.log(field,field.RelatedRecord.split('_').join('').split(' ').join('')+'Array',this.$store.state[field.RelatedRecord.split('_').join('').split(' ').join('')+'Array'],this.$store.state)
                        fieldcat.Options = this.$store.state[field.RelatedRecord.split('_').join('').split(' ').join('')+'Array']
                        fieldcat.Identifier = field.LookupFieldName
                    }
                    return fieldcat
                })
                return countobj
            })
            
        },
        WebFormEntities(){
            return this.SystemEntities.filter(entity => {
                return entity.Entity_Type && entity.Entity_Type.Name === 'Web Form'
            })
            // .map(entity => {
            //     return entity.WebTab
            // })
        },
        SurveyFormEntities(){
            return this.SystemEntities.filter(entity => {
                return entity.Entity_Type && entity.Entity_Type.Name === 'Survey Form'
            })
            // .map(entity => {
            //     return entity.WebTab
            // })
        },
        WikiType(){
            return this.$route.meta && this.$route.meta.ClassifiedListingBuilder || this.$route.meta && this.$route.meta.WikiListingBuilder
        },
        TableEmbedTables(){
            if(this.EditedTab && this.EditedTab.EntitySource === 'Photo Library'){
                return this.SystemPhotoLibraries
            }
            else if(this.EditedTab && this.EditedTab.EntitySource === 'SubCollection'){
                return this.CurrentEntity.SubCollections
            }
            else{
                return this.SystemEntities
            }
        },
        PluginDataBase(){
        return this.$store.state.PluginDataBase
        },
        RenderedContentBlocks(){	
            let prefilter = this.ContentBlocks.filter(block => {
                if(this.$route.meta && this.$route.meta.DataSingleBuilder || this.TableRecordView){
                    if(this.FeatureNavList){
                        return block
                    }
                    else{
                        return block.DataViewName !== 'Data Single Feature List'
                    }
                }
                else{
                    return !block.DataViewName
                }
            })		
            let socialcompfilter = prefilter.filter(block => {
                if(block.SocialComponent && block.SocialCompPluginid !== 'undefined' && this.GroupData){
                    return this.PublishType === 'Public' && this.GroupData[block.GroupParamsProp] === 'Public' && block.Name !== 'Site Groups' ||
                    this.PublishType === 'Members Only' && block.Name !== 'Site Groups'
                }
                else if(block.SocialComponent && block.SocialCompPluginid !== 'undefined'){
                    return this.PublishType === 'Public' && this.PluginDataBase[block.SocialCompPluginid] && this.PluginDataBase[block.SocialCompPublicBoolean] || this.PublishType === 'Members Only' && this.PluginDataBase[block.SocialCompPluginid] || this.UseGroupAssets
                }
                else if(block.SocialComponent && block.SocialCompPluginid === 'undefined'){
                    return this.PublishType === 'Public' && block.PublicPages || this.PublishType === 'Members Only'
                    //return this.PublishType === 'Public' && this.PluginDataBase[block.SocialCompPluginid] && block.PublicPages || this.PublishType === 'Members Only' && this.PluginDataBase[block.SocialCompPluginid]
                }
                else{
                    return block
                }
            })	
            // let socialcompfilter = prefilter.filter(block => {
            //     return block
            // })						
            if(this.EditedTab && this.EditedTab.DataViewName && !this.EditedTab.ParentTabType){
                let viewname = this.EditedTab.DataViewName.split(' ').join('')
                return socialcompfilter.filter(block => { 									
                    return !block.SectionType && block[viewname]                       									
                })
                .filter(block => {
                    if(!this.CurrentEntity.HasActivities){
                        return block.DataViewName !== 'Data Single Activities'
                    }
                    else{
                        return block
                    }
                })
            }
            else if(this.EditedTab && this.EditedTab.ParentTabType){
                let viewname = this.EditedTab.ParentTabType.split(' ').join('')
                return socialcompfilter.filter(block => { 									
                    return !block.SectionType && block[viewname]                       									
                })
                .filter(block => {
                    if(!this.CurrentEntity.HasActivities){
                        return block.DataViewName !== 'Data Single Activities'
                    }
                    else{
                        return block
                    }
                })
            }
            else if(this.EditedTab && !this.EditedTab.DataViewName && !this.EditedTab.ParentTabType){																		
                return socialcompfilter.filter(block => { 									
                    return !block.SectionType && !block.DataViewName                       									
                })  									
            }
            else{									
                return socialcompfilter.filter(block => { 									
                        return block.SectionType
                        //return block									
                    })									
            }									
        },	
        SingleBuildTabs(){
            return this.CurrentEntity.SingleBuildTabs
        },
        CardLinksRender(){
            let arr1 =  this.SystemEntities.map(build => {
                let obj = {
                    Name: build.DisplayName,
                    ContentLinkName: build.DisplayName,
                    ContentLinkType: 'Build',
                }
                if(build.Table_Icon){
                    obj.dataseticon = build.Table_Icon
                    obj.ContentIcon = build.Table_Icon
                }
                else{
                    obj.dataseticon = 'mdi-database'
                    obj.ContentIcon = 'mdi-database'
                }   
                return obj
            })
            let arr2 =  this.SitePages.map(build => {
                let obj = {
                    Name: build.Name,
                    ContentLinkName: build.Name,
                    ContentLinkType: 'Page',
                }
                if(build.Icon){
                    obj.dataseticon = build.Icon
                    obj.ContentIcon = build.Icon
                }
                 else{
                    obj.dataseticon = 'mdi-eye'
                    obj.ContentIcon = 'mdi-eye'
                }  
                return obj
            })
            return arr1.concat(arr2)
        },
        SystemAssetsPaginated(){									
            let displayrange = 10*this.SystemAssetsPage-10									
            return this.SystemAssets.slice(displayrange, displayrange+10)       									
        },
        BlockNameProp(){
            if(this.EditedTab && this.EditedTab.DataViewName || this.EditedTab && this.EditedTab.ParentTabType){
                return 'DataViewName'
            }
            else{
                return 'Name'
            }
        },
        DataTableswithLookuptoCurrentEntity(){
            if(this.CurrentEntity){
                return this.SystemEntities.map(entity => {
                    let entityobject = {
                        id: entity.id
                    }
                    let oncheck = entity.AllFields.find(obj => obj.RelatedBuildID === this.CurrentEntity.id)
                    if(oncheck){
                        entityobject.RelationshipField = {
                            id: oncheck.id,
                            Name: oncheck.Name,
                            DisplayName: oncheck.DisplayName,
                            Type: oncheck.Type,
                            LookupFieldName: oncheck.LookupFieldName
                        }
                        entityobject.RelationshipName = entity.DisplayName+' ('+oncheck.DisplayName+')'
                    }
                    return entityobject
                }).filter(entity => {
                    return entity.RelationshipField
                })
            }
            else{
                return []
            }
        },
        UnusedTableOptions(){
            let docregisters = this.CurrentEntity.DocumentRegisters
            let galleries = this.CurrentEntity.Galleries
            if(this.EditedTab && this.EditedTab.DataViewName === 'Data Single SubCollection'){
                return this.CurrentEntity.SubCollections.filter(opt => {
                    if(this.TableoptionsSearch){
                        return opt.DisplayName.toLowerCase().includes(this.TableoptionsSearch.toLowerCase())
                    }
                    else{
                        return opt
                    }
                })
            }
            else if(this.EditedTab && this.EditedTab.DataViewName === 'Data Single Related Data'){
                return this.DataTableswithLookuptoCurrentEntity
            }
            else if(this.EditedTab && this.EditedTab.DataViewName === 'Data Single Document Register'){
                return docregisters
            }
            else if(this.EditedTab && this.EditedTab.DataViewName === 'Data Single Gallery'){
                return galleries
            }
            else if(this.EditedTab && this.EditedTab.DataViewName === 'Data Single Cabinet'){
                
                return docregisters.concat(galleries).filter(opt => {
                    if(this.TableoptionsSearch){
                        return opt.DisplayName.toLowerCase().includes(this.TableoptionsSearch.toLowerCase())
                    }
                    else{
                        return opt
                    }
                })
            }
        },
        TableOptionsSearched(){
            let array = []
            if(this.EditedTab && this.EditedTab.DataViewName === 'Data Single Related'){
                let stringarray = ['SubCollection','Related Table']
                stringarray.map(stringopt => {
                    let arrayobj = {
                        Name: '',
                        DisplayName: '',
                        OptionType: stringopt
                    }
                    if(stringopt === 'SubCollection'){
                        arrayobj.ConfigCollection = 'SubCollections'
                        arrayobj.Headers = []
                        arrayobj.HeadersInteger = 1000000
                        
                    }
                    
                    array.push(arrayobj)
                })
            }
            else if(this.EditedTab && this.EditedTab.DataViewName === 'Data Single Cabinet'){
                let stringarray = ['Document Register','Gallery']
                stringarray.map(stringopt => {
                    let arrayobj = {
                        Name: '',
                        DisplayName: '',
                        OptionType: stringopt,
                    }
                    if(stringopt === 'Document Register'){
                        arrayobj.ConfigCollection = 'DocumentRegisters'
                    }
                    else if(stringopt === 'Gallery'){
                        arrayobj.ConfigCollection = 'Galleries'
                    }
                    array.push(arrayobj)
                })
            }
            return array.filter(item => {
                if(this.NewTableOptionSearch){
                    return item.Type.toLowerCase().includes(this.NewTableOptionSearch.toLowerCase())
                }   
                else{
                    return item
                }
            })
        },
        TableOptionsName(){
            if(this.EditedTab && this.EditedTab.DataViewName === 'Data Single Related'){
                return 'Tables'
            }
            else if(this.EditedTab && this.EditedTab.DataViewName === 'Data Single Cabinet'){
                return ' Cabinets'
            }
            else if(this.EditedTab && this.EditedTab.DataViewName === 'Data Single Document Register'){
                return ' Document Register'
            }
            else if(this.EditedTab && this.EditedTab.DataViewName === 'Data Single Gallery'){
                return ' Gallery'
            }
            else if(this.EditedTab && this.EditedTab.DataViewName === 'Data Single SubCollection'){
                return ' SubCollection'
            }
        },
        UnusedFields(){
            return this.CurrentEntity.AllFields.filter(field => {
                return !field.UsedonForm && !field.SystemRequired
            }).filter(field => {
                if(this.ExistingFieldSearch){
                    return field.Name.toLowerCase().includes(this.ExistingFieldSearch.toLowerCase()) || field.DisplayName.toLowerCase().includes(this.ExistingFieldSearch.toLowerCase())
                }
                else{
                    return field
                }
            })
        },
        ExistingFormFields(){
            return this.CurrentEntity.AllFields.filter(field => {
                return field.UsedonForm && !field.SystemRequired
            }).filter(field => {
                if(this.EditedTab){
                    let fields = this.EditedTab.Fields.map(tabfield => {return tabfield.id})
                    return fields.includes(field.id)
                }
                else{
                    return field
                }
            })
            .filter(field => {
                if(this.ExistingFormFieldSearch){
                    return field.Name.toLowerCase().includes(this.ExistingFormFieldSearch.toLowerCase()) || field.DisplayName.toLowerCase().includes(this.ExistingFormFieldSearch.toLowerCase())
                }
                else{
                    return field
                }
            })
        },
        
        LookupEntitiesSubCols(){
            return this.SystemEntities.map(entity => {
                let entityobject = {
                    id: entity.id,
                    AllFields: entity.AllFields,
                    Headers: entity.AllFields.filter(field => {return field.IsHeader}).map(field => {if(!field.text){
                        field.text = field.DisplayName
                        field.value = field.Name
                        }
                        return field}),
                    dataseticon: entity.Table_Icon,
                    identifier: entity.RecordPrimaryField.Name,
                    recordprimaryfield: entity.RecordPrimaryField,
                    tempname: entity.SingleName,
                    temppluralname: entity.DisplayName,
                    single: entity.SingleName.split(' ').join(''),
                    SubCollections: entity.SubCollections.map(subcol => {return subcol.id}),
                    Entity_Type: entity.Entity_Type,
                    LinkedFields: {}
                }
                return entityobject
            })
        },
        LookupEntities(){
            return this.SystemEntities.filter(entity => {
                return entity.id !== this.CurrentEntity.id
            })
        },
        BasicFieldTypes(){
            return this.FieldTypes.filter(field => {
                return field.Type === 'Single Line Text' || field.Type === 'Multiple Lines Text' || field.Type === 'Boolean'
            })
        },
        FieldTypesSearched(){
            return this.FieldTypes.filter(field => {
                if(this.NewFieldSearch){
                    return field.Type.toLowerCase().includes(this.NewFieldSearch.toLowerCase())
                }   
                else{
                    return field
                }
            })
        },
        HeaderNames() {
            return this.ImportHeaders.map(header => {
                return header.value.split('.')[0]
            }).filter(header => {
                return header !== 'id'
            })
            },
        HeaderNamesSplit() {
            return this.HeaderNames.map(header => {
            let correctheader = header
                return correctheader
            })
        },

    },
    watch: {        
        RenderedContentBlocks : {
            handler: function(newvalue, oldvalue) {
                //console.log(this.RenderedContentBlocks)
                if(newvalue !== oldvalue){
                    this.$emit('AssignRenderedContentBlocks',this.RenderedContentBlocks)
                }
            }
        },
        SelectedActiveButton : {
            handler: function(newvalue, oldvalue) {
                //console.log(newvalue, oldvalue)
                if(newvalue !== oldvalue){
                    this.ActiveButtoncompname = this.SelectedActiveButton.compname
                    this.ActiveButtonName = this.SelectedActiveButton.Name
                }
            }
        },
        LoadedPageBGGradient (value) {
            if (value !== null && value !== undefined) {
               this.PageBGGradient = value
            }
        },
        LoadedPageBGAsset (value) {
            if (value !== null && value !== undefined) {
               this.PageBGAsset = value
            }
        },
        LoadedPageBGColor (value) {
            if (value !== null && value !== undefined) {
               this.PageBGColor = value
            }
        },
        LoadedPageName (value) {
            if (value !== null && value !== undefined) {
               this.PageName = value
            }
        },
        LoadedPageRoute (value) {
            if (value !== null && value !== undefined) {
               this.PageRoute = value
            }
        },
        LoadedPageIcon (value) {
            if (value !== null && value !== undefined) {
               this.PageIcon = value
            }
        },
        LoadedPageOverview (value) {
            if (value !== null && value !== undefined) {
               this.PageOverview = value
            }
        },
        LoadedPublishType (value) {
            if (value !== null && value !== undefined) {
               this.PublishType = value
            }
        },
        LoadedPageContentFont (value) {
            if (value !== null && value !== undefined) {
               this.PageContentFont = value
            }
        },
        LoadedPageHeadersFontSize (value) {
            if (value !== null && value !== undefined) {
               this.PageHeadersFontSize = value
            }
        },
        LoadedPageHeadersFont (value) {
            if (value !== null && value !== undefined) {
               this.PageHeadersFont = value
            }
        },
    },
    created(){
        // console.log('this.WikiEntities',this.WikiEntities)
        // console.log('this.FrequentlyAskedQuestions',this.FrequentlyAskedQuestions)
        this.$emit('AddContentBlocks',this.ContentBlocks)
        this.$emit('AssignRenderedContentBlocks',this.RenderedContentBlocks)
        if(this.WikiType){
            if(!this.CurrentEntity.WikiFields){
                this.CurrentEntity.WikiFields = []
            }
        }
        if(this.LoadedPageName){
            this.PageName = this.LoadedPageName
        }
        if(this.LoadedPageRoute){
            this.PageRoute = this.LoadedPageRoute
        }
        if(this.LoadedPageBGGradient){
            this.PageBGGradient = this.LoadedPageBGGradient
        }
        if(this.LoadedPageBGAsset){
            this.PageBGAsset = this.LoadedPageBGAsset
        }
        if(this.LoadedPageBGColor){
            this.PageBGColor = this.LoadedPageBGColor
        }        
        if(this.LoadedPageIcon){
            this.PageIcon = this.PageIcon
        }        
        if(this.LoadedPageOverview){
            this.PageOverview = this.LoadedPageOverview
        }
        if(this.LoadedPublishType){
            this.PublishType = this.LoadedPublishType
        }
        else if(this.ClsfdNavList){
            this.PublishType = this.ClsfdNavList.PublishType
        }
        if(this.LoadedPageContentFont){
            this.PageContentFont = this.LoadedPageContentFont
        }
        if(this.LoadedPageHeadersFontSize){
            this.PageHeadersFontSize = this.LoadedPageHeadersFontSize
        }
        if(this.LoadedPageHeadersFont){
            this.PageHeadersFont = this.LoadedPageHeadersFont
        }
        if(this.$route.query && this.$route.query.PublishType){
            this.PublishType = this.$route.query.PublishType
        }
        
        
    },
    methods:{
        ToggleElementAnimationDialog(EditedTab){
            EditedTab.ContentItems = this.TabStyleItems.filter(item => {
                return item.ContentElementID
            }).map(item => {
                return item.ContentElementID
            }).concat(['Tab'])
            console.log(EditedTab)            
            this.$store.commit('SetEditedPageProperties',{
                PageHeadersFont: this.PageHeadersFont,
                PageContentFont: this.PageContentFont,
                PageHeadersFontSize: this.PageHeadersFontSize,
            })
            this.$store.commit('setEditedTab',EditedTab)
            this.$store.commit('ToggleElementAnimationDialog') 
        },
        AddContentDialog(EditedTab){
            if(EditedTab.ContentDialogType){
                let contentbox = this.ContentBlocks.find(obj => obj.Name === EditedTab.ContentDialogType.Name)
                EditedTab.ContentDialogBox = Object.assign({},contentbox)
                EditedTab.ContentDialogBox.Elevation = 0
                EditedTab.ContentDialogBox.Tile = true
                EditedTab.ContentDialogBox.Flat = true
                EditedTab.ContentDialogBox.IsContentDialog = true
            }
        },
        
        ActivateNewElement(index){
            let tab = Object.assign(this.EditedTab) 
            let parentindex = this.EditedTabindex
            let elmnt = tab.Elements[index]           
            this.DeactivateTabDialog()
            this.$emit('OpenDialog',elmnt,index,true,parentindex)
        },
        RefreshField(field){
        this.RefreshingNewField = true
        setTimeout(() => {
          this.RefreshingNewField = false
        }, 100);
      },
        AddGuideConditionalDisabledBoolean(guide){
            if(!guide.ConditionalBooleans){
                guide.ConditionalBooleans = []
            }
            guide.ConditionalBooleans.push({
                Field: '',
                Value: true
            })
            guide.ConditionalDisabled = false
            setTimeout(() => {
                guide.ConditionalDisabled = true
            }, 200);
            console.log(guide)
            },
        AssignImage(tab,prop,asset,IsThis){
            this.$emit('AssignImage',tab,prop,asset,IsThis)
        },
        RefreshPanels(EditedTab){
            EditedTab.WrapInExpansionPanel = false
            EditedTab.WrapInExpansionPanel = true
            this.RefreshComponent(EditedTab)
        },
        RemovePanel(EditedTab,panelindex){
            EditedTab.Panels.splice(panelindex,1)
            this.RefreshPanels(EditedTab)
        },
        PrepareForPanels(EditedTab){
            if(!EditedTab.Panels){
                EditedTab.Panels = []
            }            
        },
        AddListPanels(EditedTab){
            let newpanel = {
                Title: 'Some Title',
                ListItems: [],
            }
            EditedTab.Panels.push(newpanel)
            this.RefreshPanels(EditedTab)
            console.log(EditedTab)
        },
        ActivateNewWikiFieldDialog(DefaultType){
            this.NewWikiFieldDialog = true
            this.NewfieldType = DefaultType
        },
        CancelAddNewWikiField(){
            this.NewWikiFieldDialog = false
            this.NewFieldName = ''
            this.NewfieldType = ''
        },
        AddNewWikiField(){
            let newwikifield = {
                Name: this.NewFieldName.split(' ').join('_'),
                Type: this.NewfieldType,
                Source: 'Page Record Prop'
            }
            this.ProcessAddNewWikiField(newwikifield)
            this.CancelAddNewWikiField()
        },
        ProcessAddNewWikiField(newwikifield){
            if(!this.CurrentEntity.WikiFields){
                this.CurrentEntity.WikiFields = []
            }
            let oncheck = this.CurrentEntity.WikiFields.find(obj => obj.Name === newwikifield.Name)
            if(!oncheck){
                this.CurrentEntity.WikiFields.push(newwikifield)
            }
            // this.WikiSourceDialog = false
            // setTimeout(() => {
            //         this.WikiSourceDialog = true
            // }, 1000);
            console.log(this.CurrentEntity)
        },
        UpdateWikiSource(EditedTab,SourceProps){
            EditedTab.SourceProps = SourceProps
            EditedTab.SourceProps.map(prop => {
                if(!prop.IsArray){
                    //actually just assign the values now
                    if(prop.SourceType === 'Data Field' || prop.SourceType === 'Page Record Prop'){
                        let value = this.DynamicWikiData[prop.DataProp.Name]
                        
                        if(value !== 'undefined'){
                            if(prop.DataProp.Type === 'Lookup'){
                                value = value[prop.DataProp.LookupFieldName]
                            }
                            else if(prop.DataProp.Type === 'Option Set'){
                                value = value.Name
                            }
                            else if(prop.DataProp.Type === 'Single File Upload'){
                                value = value.url
                            }
                            EditedTab[prop.ElementProp] = value
                        }                  
                            let newwikifield = Object.assign({},prop.DataProp)
                            newwikifield.Source = 'Data Field'
                            console.log('SourceType value',prop.DataProp.Name,value,prop.ElementProp,EditedTab)
                            this.ProcessAddNewWikiField(newwikifield)                    
                    }
                }
                else{
                    if(prop.SourceType === 'Data Field'){
                        let arrayobj = this.CurrentEntity[prop.EntityProp].find(obj => obj.id === prop.DataProp)
                        if(arrayobj){
                            EditedTab[prop.ElementProp] = arrayobj.DataArray.map(item => {
                                if(item.url){
                                    item.URL = item.url
                                }
                                return item
                            })
                        }
                    }
                }
               
               
            })
           
            console.log(EditedTab,this.CurrentEntity)
        },
        CancelWikiSourceDialog(){
            this.WikiSourceDialog = false
        },
        UpdateWikiValue(EditedTab,tabprop,recordfield){
            if(typeof this.DynamicWikiData[recordfield.Name] !== 'undefined'){
                if(tabprop !== 'IMG'){
                 EditedTab[tabprop] = this.DynamicWikiData[recordfield.Name]   
                }
                else if(tabprop === 'IMG'){
                 EditedTab[tabprop] = this.DynamicWikiData[recordfield.Name].fileurl
                }
            }
            else{
                EditedTab[tabprop] = ''
            }
            
        },
        RefreshComponent(EditedTab){
            EditedTab.ShowComponents = false
            setTimeout(() => {
                    EditedTab.ShowComponents = true
            }, 100);
        },
        AssignFAQList(EditedTab){
            //actually we need to record to the FAq, possibly vie cloud fucniton, that this page uses it
        },
        AssignDescriptionList(EditedTab){
            console.log(EditedTab,this.DynamicWikiData)
            if(!EditedTab.WrapInExpansionPanel){
             EditedTab.ListItems = EditedTab.ListItems.map(listitem => {
                if(!listitem.Record){
                    listitem.Record = {}
                }
                if(typeof this.DynamicWikiData[listitem.Name] !== 'undefined'){
                    listitem.Record[listitem.Name] = this.DynamicWikiData[listitem.Name]   
                }
                else if(listitem.Type === 'Boolean'){
                    listitem.Record[listitem.Name] = false
                } 
                else if(listitem.Type === 'Number Field'){
                    listitem.Record[listitem.Name] = 0
                }
                else{
                    listitem.Record[listitem.Name] = 'Insert Value'
                }             
                return listitem
            })   
            }
            else{
                EditedTab.Panels.map(panel => {
                    panel.ListItems = panel.ListItems.map(listitem => {
                    if(!listitem.Record){
                        listitem.Record = {}
                    }
                    if(typeof this.DynamicWikiData[listitem.Name] !== 'undefined'){
                    listitem.Record[listitem.Name] = this.DynamicWikiData[listitem.Name]   
                    }
                    else if(listitem.Type === 'Boolean'){
                        listitem.Record[listitem.Name] = false
                    } 
                    else if(listitem.Type === 'Number Field'){
                        listitem.Record[listitem.Name] = 0
                    }
                    else{
                        listitem.Record[listitem.Name] = 'Insert Value'
                    } 
                    return listitem
                })
                })
            }
            
            EditedTab.ShowComponents = false
            setTimeout(() => {
                    EditedTab.ShowComponents = true
            }, 100);
        },
        
        AssignWikiBasedGallery(EditedTab){
            EditedTab.Assets = []
             this.DynamicWikiData[EditedTab.Galleryid].map(asset => {
                this.Twopropemit('AssignGalleryAssets',EditedTab,asset)
            })
        },
        SavePage(PublishType,PageName,PageOverview,PageContentFont,PageHeadersFontSize,PageHeadersFont,PageIcon,PageBGGradient,PageBGAsset,PageBGColor){
            console.log(PublishType,PageName,PageOverview,PageContentFont,PageHeadersFontSize,PageHeadersFont,PageIcon,PageBGGradient,PageBGAsset,PageBGColor)
            this.$emit('SavePage',PublishType,PageName,PageOverview,PageContentFont,PageHeadersFontSize,PageHeadersFont,PageIcon,PageBGGradient,PageBGAsset,PageBGColor)
        },
        TabImageHasClipping(EditedTab){
            return !EditedTab.DataViewName ? EditedTab.Name === 'Parallax' || EditedTab.Name === 'Image' || EditedTab.HasImage || EditedTab.Name === 'Clipped Tab' : ''
        },
        
        TabImageHasSizing(EditedTab){
            return !EditedTab.DataViewName ? EditedTab.Name === 'Parallax' || EditedTab.Name === 'Image' || EditedTab.Name === 'Clipped Tab' || EditedTab.HasImage && EditedTab.Name !== 'Card Block Single' && EditedTab.Name !== 'Card Row Single' : ''
        },
        ConfigureTable(tab){
            console.log(tab)
            if(tab.EntitySource === 'SubCollection'){
                let opt = this.CurrentEntity.SubCollections.find(obj => obj.id === tab.Entityid)
                this.ActivateTableOptionDialog(opt)
            }
            else if(tab.DataViewName === 'Data Single Document Register'){
                let opt = this.CurrentEntity.DocumentRegisters.find(obj => obj.id === tab.Entityid)
                this.ActivateTableOptionDialog(opt)
            }
            else if(tab.DataViewName === 'Data Single Gallery'){
                let opt = this.CurrentEntity.Galleries.find(obj => obj.id === tab.Entityid)
                this.ActivateTableOptionDialog(opt)
            }
        },
        UpdateField(field,prop,value){
            field[prop] = value
            if(!this.AddingNewField){
                
            }
            console.log(field)
        },
        onImportfileSelected(event){
        this.ImportFile = event.target.files[0]
        },
        DownloadFieldsImportTemplate(){
            let copyText = this.HeaderNamesSplit
            var csvfilename = 'FieldsImportTemplate.csv'
            var element = document.createElement('a');
            element.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(copyText))
            element.setAttribute('download', csvfilename)
            document.body.appendChild(element);
            element.click();
            document.body.removeChild(element);
            // }
        },
        closeImport(){
        this.importdialog = false
        this.ImportFile = null
        this.ImportFileSessionName = ''
        },
        saveImport() {
            let importLocalURL = URL.createObjectURL(this.ImportFile)
            var reader = new FileReader();
            let test = reader.readAsText(this.ImportFile);
            let vm = this
            reader.addEventListener('load', function(e) {
                    var text = e.target.result;
                    vm.CSVConvertToJSON(text)
            });
        },
        CSVConvertToJSON(text){        
            this.NewImportsArray = []
            this.PartialFailuresArray = []            
            let lines = text.split("\n")
            this.CheckDelimiter(lines)        
        },

        CheckDelimiter(lines){
            console.log(lines)
            let headertest = lines[0].split(";");
            console.log('headertest')
            console.log(headertest)
            if(headertest.length === 1){
                console.log('used ,')
                this.ConversionCSVtoJJSON(lines,',')                
            }
            else{
                console.log('used ;')
                this.ConversionCSVtoJJSON(lines, ';')
                
            }        
        },
        ConversionCSVtoJJSON(lines,delimiter){
            let dataonly = Object.assign([],lines)
            dataonly.splice(0,1)
            console.log(dataonly)
            console.log('delimiter')
            console.log(delimiter)
            this.CSVResult = []
            this.ImportHeaders=lines[0].split(delimiter);
            console.log('this.ImportHeaders')
            console.log(this.ImportHeaders)
            for(var i=1;i-1+2<lines.length;i++){
            var obj = {};
            var currentline=lines[i].split(delimiter);            
            for(var j=0;j<this.ImportHeaders.length;j++){
                if(this.ImportHeaders[j] === 'Name'){
                obj[this.ImportHeaders[j]] = currentline[j].split(' ').join('_');
                }
                else{
                obj[this.ImportHeaders[j]] = currentline[j];
                }                
            }            
            this.CSVResult.push(obj);
            console.log("this.CSVResult length is "+this.CSVResult.length)
            }
            this.CSVResult.map((res,i) => {                
                delete res.dud
                console.log('res')
                console.log(res)
                this.AddField(res)
                if(i-1+2 === this.CSVResult.length){
                    this.closeImport()
                }
            })
        },
        CheckForPrimary(subcol,value,header,headerindex){
            console.log(value,header)
            if(value && header){
                if(value.Primary){
                    subcol.Headers[headerindex].Primary = value.Primary
                    console.log(subcol)
                }
            }
        },
        ActivateTableOptionDialog(tableoption){
            this.NewTableOption = Object.assign({},tableoption)
            if(this.NewTableOption.ConfigCollection === 'SubCollections' && this.NewTableOption.Type === 'Lookup' && this.NewTableOption.LookupBuilds){
                  this.NewTableOption.LookupBuilds = this.NewTableOption.LookupBuilds.map(build => {
                  let lookupbuild = this.SystemEntities.find(obj => obj.id === build.id)
                  console.log(build.id,this.NewTableOption,this.NewTableOption.LookupBuilds,lookupbuild)
                  if(lookupbuild){
                    build.AllFields = lookupbuild.AllFields
                    build.Entity_Type = lookupbuild.Entity_Type
                  }
                  return build
                  })
            }
             //.DocRegAdditionalFields.map?
            this.SampleTableOption = Object.assign({},tableoption)
            this.SampleTableOption.BGColor = {									
                    hex: '#ffffff',
                    hexa: '#ffffffff',									
            }
            console.log(this.SampleTableOption)
            this.NewTableOptionDialog = true
        },
        ResetTableOptionDialog(){
            this.NewTableOptionDialog = false
            
            this.SampleTableOption.Entityid = this.NewTableOption.Name.split(' ').join('_')
            this.SampleRecord.SubCollections = []
            this.SampleRecord.SubCollections.push(this.NewTableOption)
            if(this.SampleTableOption.OptionType === 'SubCollection'){
                this.SampleTableOption.EntitySource = 'SubCollection'
            }
            console.log(this.NewTableOption,this.SampleTableOption)
            setTimeout(() => {
                    this.NewTableOptionDialog = true
            }, 10);
        },
        CancelTableOptionDialog(){
            this.NewTableOptionDialog = false,
            this.NewTableOption = ''
            this.SampleTableOption = ''
            console.log(this.NewTableOption)
            //this.NewTableOption = ''
        },
        ActivateNewFieldDialog(field,AddingNewField,ListPanel){
            console.log('field',field)
            this.NewField = Object.assign({},field)
            this.NewFieldDialog = true
            this.AddingNewField = AddingNewField
            this.ListPanel = ListPanel
            console.log(this.EntityCollectionRef,field)
            // if(tableoption){
            //     this.NewTableOption = tableoption 
            // }
        },
        CancelNewFieldDialog(){
            this.NewFieldDialog = false,
            this.NewField = ''
             this.AddingNewField = false
             this.ListPanel = ''
            //this.NewTableOption = ''
        },
        AddTableOption(opt){
            if(!opt.DisplayName){
             opt.DisplayName = opt.Name   
            }            
            opt.Name = opt.Name.split(' ').join('_')     
            console.log(opt)
            if(opt.Options){
            opt.PrimaryOptions = opt.Options
            opt.PrimaryOptionsInteger = opt.lastassignedinteger
            delete opt.Options
            delete opt.lastassignedinteger     
            this.NoPropsemit('CancelOptionSetDialog')
            }
            //.DocRegAdditionalFields.map?
            opt.MultipleFileUploadType = opt.OptionType
            opt.SectionType = opt.OptionType                
            this.$emit('AddTableOption',opt)
            
        },
        UpdateRelated(field,RelatedBuildID){
            let array = []
            if(field.Type === 'Lookup'){
                array = this.SystemEntities
            }
            else{
                array = this.$store.state.SocialEntities
            }
            let entity = array.find(obj => obj.id === RelatedBuildID)
            if(entity){
                field.RelatedLocation = entity.SingleName
                field.RelatedRecord = entity.DisplayName
                field.LookupFieldName = entity.RecordPrimaryField.Name
            }
        },
        UpdateFieldOptions(field,optprop,intname){
            field[intname] = field[intname]-1+2
            let firstoptions = JSON.parse(JSON.stringify(field[optprop]))
            let newoptions = firstoptions.map(opt => {
                if(typeof opt === 'string'){
                    opt = {}
                    opt.ID = field[intname],
                    opt.Name = opt
                }
                return opt
            })
            console.log(newoptions)
            field[optprop] = newoptions
        },
        AddField(field){
            console.log(this.NewTableOption)
            if(!field.Name){
             field.Name = field.DisplayName.split(' ').join('_')   
            }  
            field.id = field.Name          
            field.text = field.DisplayName
            field.value = field.Name
            console.log(field)
            if(!this.NewTableOption && !this.ListPanel){
                this.$emit('AddField',field)
            }
            else if(this.ListPanel){
                let value = Object.keys(this.SampleRecord)[0]
                if(typeof value !== 'undefined'){
                  value = value
                }
                else if(field.Type === 'Boolean'){
                    value = false
                }
                else{
                    value = 'Insert Value'
                }
                field.Record = {[field.Name]: value}
                this.ListPanel.ListItems.push(field)
                this.SampleRecord = {}
                setTimeout(() => {
                        this.CancelNewFieldDialog()
                    }, 50);
            }
            else if(this.NewTableOption.OptionType === 'SubCollection'){
                this.NewTableOption.Headers.push(field)
                this.NewTableOption.HeadersInteger = this.NewTableOption.HeadersInteger-1+2
                if(!this.ImportFileSessionName){
                    setTimeout(() => {
                        this.CancelNewFieldDialog()
                    }, 50);   
                }
                
            }
            
        },
        DeactivateTabDialog(){
            this.$emit('DeactivateTabDialog')
        },
        NoPropsemit(MethodName){
            this.$emit('NoPropsemit',MethodName)
        },
        TabPropEmit(MethodName){
            this.$emit('TabPropEmit',MethodName)
        },
        Onepropemit(MethodName,prop){
            console.log(MethodName,prop)
            this.$emit('Onepropemit',MethodName,prop)
        },
        Twopropemit(MethodName,firstprop,secondprop){
            this.$emit('Twopropemit',MethodName,firstprop,secondprop)
            setTimeout(() => {
                this.TypeChange = ''
            }, 50);
        },
        Threepropemit(MethodName,firstprop,secondprop,thirdprop){
            this.$emit('Threepropemit',MethodName,firstprop,secondprop,thirdprop)
        },
        OpenDialog(tab,tabindex,IsElement,CustomBoxTabIndex,isrow,rowindex,ContentDialog){
            this.$emit('OpenDialog',tab,tabindex,IsElement,CustomBoxTabIndex,isrow,rowindex,ContentDialog)
        },       
        
    }
}
</script>

<style>

</style>